var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEcommercecampaignAmico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-5",
    d: "M449.17,330.26l-27.3-15.91-27.3,15.91,27.3,15.91ZM420.52,347,393.22,331,365.93,347l27.29,15.91Zm-28.64,16.7-27.3-15.92-27.3,15.92,27.3,15.91Zm-57.29,33.39-27.3-15.91L280,397.05,307.29,413Zm28.64-16.7-27.3-15.91-27.29,15.91,27.29,15.92ZM421.87,281l-27.3,15.91,27.3,15.91,27.3-15.91Zm-55.94-34.18,27.29,15.91,27.3-15.91-27.3-15.92Zm-60,133.58-27.3-15.91-27.29,15.91,27.29,15.92Zm31.34-150.28L364.58,246l27.3-15.91-27.3-15.92Zm84.59,17.48-27.3,15.91,27.3,15.92,27.3-15.92ZM162.72,363.66l-27.3-15.92-27.3,15.92,27.3,15.91ZM50.83,296.86l27.3,15.92,27.3-15.92L78.13,281Zm28.65-16.7,27.3,15.92,27.29-15.92-27.29-15.91Zm57.29-33.39,27.3,15.91,27.29-15.91-27.29-15.92Zm-28.65,16.7,27.3,15.91,27.3-15.91-27.3-15.92Zm-30,82.7,27.3-15.91-27.3-15.91-27.3,15.91ZM277.3,397.05,250,381.14l-27.3,15.91L250,413Zm-111.89-167L192.71,246,220,230.07l-27.3-15.91Zm83.24,150.28-27.3-15.91-27.29,15.91,27.29,15.92Zm60-167,27.3,15.91,27.29-15.91-27.3-15.91ZM134.07,347,106.78,331,79.48,347l27.3,15.91Zm57.29,33.39-27.3-15.91-27.29,15.91,27.3,15.92ZM220,397.05l-27.3-15.91-27.3,15.91L192.71,413Zm-28.65,16.7-27.29-15.91-27.3,15.91,27.29,15.91ZM220,430.45l-27.3-15.91-27.3,15.91,27.3,15.91Zm-57.29-33.4-27.3-15.91-27.3,15.91L135.42,413Zm-28.65-16.7-27.29-15.91-27.3,15.91,27.3,15.92Zm-28.64-16.69-27.3-15.92-27.3,15.92,27.3,15.91Zm200.51,50.09-27.3-15.91-27.29,15.91,27.29,15.91Zm57.29,0-27.3-15.91-27.29,15.91,27.29,15.91Zm-114.58,0-27.3-15.91-27.29,15.91,27.29,15.91Zm85.94,16.7-27.3-15.91L280,430.45l27.3,15.91Zm-57.29,0L250,414.54l-27.3,15.91L250,446.36ZM49.49,362.87,76.78,347,49.49,331,22.19,347ZM280,196.67l27.3,15.91,27.3-15.91-27.3-15.91Zm-143.22,16.7,27.3,15.91,27.29-15.91-27.29-15.91Zm28.64-16.7,27.3,15.91L220,196.67l-27.3-15.91Zm28.65,16.7,27.3,15.91,27.29-15.91-27.29-15.91ZM49.49,329.47l27.29-15.91L49.49,297.65l-27.3,15.91ZM222.7,196.67,250,212.58l27.3-15.91L250,180.76Zm28.65,16.7,27.29,15.91,27.3-15.91-27.29-15.91ZM22.19,280.16l27.3,15.92,27.29-15.92L49.49,264.25Zm28.64-16.69,27.3,15.91,27.3-15.91-27.3-15.92Zm28.65-16.7,27.3,15.91,27.29-15.91-27.29-15.92Zm28.64-16.7L135.42,246l27.3-15.91-27.3-15.91ZM277.3,363.66,250,347.74l-27.3,15.92L250,379.57ZM220,330.26l-27.3-15.91-27.3,15.91,27.3,15.91Zm85.93-16.7-27.3-15.91-27.29,15.91,27.29,15.91Zm-28.64,16.7L250,314.35l-27.3,15.91L250,346.17Zm0-33.4L250,281l-27.3,15.91L250,312.78Zm-28.65,16.7-27.29-15.91-27.3,15.91,27.29,15.91Zm85.94-16.7L307.29,281,280,296.86l27.3,15.91Zm0,33.4-27.3-15.91L280,330.26l27.3,15.91Zm-83.24-50.1,27.29,15.92,27.3-15.92-27.29-15.91ZM280,263.46l27.3,15.92,27.3-15.92-27.3-15.91Zm111.89,33.4L364.58,281l-27.3,15.91,27.3,15.91Zm-28.65,16.7-27.3-15.91-27.29,15.91,27.29,15.91ZM222.7,263.46,250,279.38l27.3-15.92L250,247.55Zm265.17,21c-.84-2.33-1.75-4.66-2.79-7l-4.57,2.66Zm-39.18-52.54-1.13-.92h0l1.12.92Zm36.39,45.58h0Zm-16.15-25.56h0l.87,1.07ZM220,296.86,192.71,281l-27.3,15.91,27.3,15.92Zm267.88-12.39h0c.14.38.3.77.43,1.16C488.16,285.24,488,284.85,487.89,284.47Zm-8.73-5.09,5.36-3.13A112.46,112.46,0,0,0,469.8,253l-17.94,10.45ZM136.77,313.56l27.3,15.91,27.29-15.91-27.29-15.91ZM421.87,246l25.67-15c-3.53-2.86-7.24-5.67-11.18-8.41h0l-14.49-8.45-27.3,15.92Zm28.64,16.7,18.42-10.74a151.37,151.37,0,0,0-20.27-20l-25.44,14.84ZM363.23,347,335.93,331,308.64,347l27.29,15.91Zm30-82.71-27.29,15.91,27.29,15.92,27.3-15.92Zm27.3,49.31-27.3-15.91-27.29,15.91,27.29,15.91Zm-85.93,50.1-27.3-15.92L280,363.66l27.3,15.91Zm2.69-100.2,27.3,15.92,27.3-15.92-27.3-15.91ZM194.06,246.77l27.3,15.91,27.29-15.91-27.29-15.92Zm197.82,83.49-27.3-15.91-27.3,15.91,27.3,15.91ZM251.35,246.77l27.3,15.91,27.29-15.91-27.3-15.92Zm-28.65-16.7L250,246l27.3-15.91L250,214.15Zm57.29,0L307.29,246l27.3-15.91-27.3-15.92Zm28.65,16.7,27.29,15.91,27.3-15.91-27.3-15.92ZM220,363.66l-27.3-15.92-27.3,15.92,27.3,15.91ZM79.48,313.56l27.3,15.91,27.29-15.91-27.29-15.91Zm28.64-16.7,27.3,15.92,27.3-15.92L135.42,281Zm54.6,33.4-27.3-15.91-27.3,15.91,27.3,15.91Zm2.69-66.79,27.3,15.91L220,263.46l-27.3-15.91Zm-28.64,16.69,27.3,15.92,27.29-15.92-27.29-15.91ZM305.94,347,278.64,331,251.35,347l27.29,15.91Zm-114.58,0L164.07,331,136.77,347l27.29,15.91Zm57.29,0L221.35,331,194.06,347l27.29,15.91Zm143.23,50.09-27.3-15.91-27.3,15.91L364.58,413ZM194.06,280.16l27.3,15.92,27.29-15.92-27.29-15.91Zm114.58,0,27.29,15.92,27.3-15.92-27.3-15.91ZM108.38,428.73l1.57.66h0l-1.57-.66Zm35.92,12.46,1.82.5h0l-1.81-.52Zm-37.52-43.35-27.3,15.91L94,422.2q7,3.45,14.41,6.53l25.69-15ZM186,450.27c.71.12,1.42.22,2.14.33h0l-2.15-.32Zm14.1,2,3.39.41,0,0c-1.13-.12-2.26-.26-3.39-.4ZM235.22,455l2.05.07-2.05-.07Zm2.55.08q12.22.36,24.47,0L250,447.93Zm-16.42-23.82-27.29,15.91,9.39,5.47c10.51,1.19,21.12,2,31.77,2.36l13.43-7.83Zm-33.19,19.35q5.93.9,11.9,1.63l-7.35-4.29Zm-52.74-36L110,429.39a313.52,313.52,0,0,0,34.37,11.78l18.4-10.72Zm28.64,16.7-17.93,10.45A367.19,367.19,0,0,0,186,450.27l5.35-3.12Zm114.58,0-27.29,15.91L264.78,455c10.65-.37,21.26-1.17,31.77-2.36l9.39-5.47Zm-257.8-83.5-5.35,3.12A112.2,112.2,0,0,0,30.2,374.11l17.94-10.45ZM51.31,395.2l1.13.92h0l-1.13-.92Zm12.33,9.32Zm174.12,50.55h-.49ZM14.92,349.62l.56,1.25h0c-.19-.41-.37-.83-.55-1.25Zm-2.81-7c.83,2.33,1.79,4.65,2.83,7L19.49,347Zm37.38,21.79L31.07,375.18a151.87,151.87,0,0,0,20.26,20l25.45-14.84Zm247,88.21,2.93-.35-2.89.32ZM264.78,455h0c-.84,0-1.69.07-2.54.09C263.09,455.05,263.94,455,264.78,455ZM105.43,397.05l-27.3-15.91-25.67,15c3.53,2.86,7.24,5.67,11.18,8.41L78.13,413Zm346.43-66.79,27.3,15.91,9.43-5.5a86.87,86.87,0,0,0,4-18.49l-13.44-7.83Zm33.2,19.35c1-2.31,2-4.63,2.83-7L480.51,347Zm-33.2,14.05,17.94,10.45a112.2,112.2,0,0,0,14.71-23.25l-5.35-3.12Zm-57.29,33.39L421.87,413l14.49-8.45q5.91-4.11,11.2-8.4l-25.69-15Zm93.32-54.4c.24-.66.48-1.32.7-2-.22.66-.46,1.32-.7,2Zm-64.67,37.7,25.47,14.85a151.13,151.13,0,0,0,20.24-20l-18.42-10.74Zm61.3-29.48.56-1.25h0c-.18.42-.36.84-.55,1.25Zm8.23-44.45-12.24,7.14,12.24,7.14A83,83,0,0,0,492.75,306.42Zm-.15-1.48.15,1.48h0ZM48.14,330.26l-27.3-15.91L7.41,322.18a87.24,87.24,0,0,0,4,18.51l9.4,5.48Zm431-49.31-27.3,15.91,27.3,15.91,13.44-7.83a86.87,86.87,0,0,0-4-18.49Zm13.44,41.23h0l.15-1.48h0Zm-184,125,5.33,3.11a366.84,366.84,0,0,0,39.89-8.57l-17.93-10.45Zm-8.73,5.09q6-.74,11.94-1.65l-4.56-2.66Zm54-10.55,1.22-.34-1.23.34Zm-42,8.91c.71-.11,1.43-.21,2.14-.33h0c-.7.11-1.41.23-2.12.33Zm-12,1.64h0l-.46.05Zm110-32-3.83,1.9-.06,0Zm-16.7-22.42-27.29,15.91,25.69,15q7.39-3.11,14.47-6.57l14.43-8.41Zm54.34-1.72,1.13-.92-1.13.92Zm-11.2,8.4Zm-99.08,25.93,18.42,10.74a313.27,313.27,0,0,0,34.35-11.81l-25.47-14.84Zm52.77-1.07,1.57-.65-1.57.65ZM335.93,195.89l17.95-10.46A367.37,367.37,0,0,0,314,176.85L308.64,180Zm-57.28,0L305.94,180l-9.43-5.5c-10.49-1.18-21.09-1.95-31.73-2.33L251.35,180Zm-90.51-19.37h0Zm205.08,52.76,27.3-15.91L406,204.92q-7-3.45-14.41-6.53l-25.69,15Zm27.3,151.07-27.3-15.91-27.29,15.91,27.29,15.92ZM364.58,212.58,390,197.74a310.27,310.27,0,0,0-34.34-11.8l-18.42,10.73Zm-52.73-36.05c-4-.6-8-1.16-12-1.65l7.39,4.31Zm-108.36-2.06-3.39.41,3.39-.41Zm-3.39.41q-6,.74-12,1.64l4.57,2.67Zm21.26,21L248.65,180l-13.43-7.83c-10.64.38-21.24,1.15-31.73,2.33l-9.43,5.5Zm16.4-23.84h0Zm-2.54.09h0l2.38-.08Zm27-.09q-12.23-.36-24.48,0L250,179.19Zm188.27,125.6-27.29,15.91,27.29,15.91,27.3-15.91Zm0-33.4-27.29,15.91,27.29,15.92,27.3-15.92ZM406,204.92Zm-106.13-30-3.39-.41,3.39.41ZM477.81,347,450.51,331,423.22,347l27.29,15.91Zm-28.64,16.7-27.3-15.92-27.3,15.92,27.3,15.91ZM390.05,197.74h0l.44.18ZM314,176.85c-.71-.12-1.42-.22-2.14-.33h0l2.14.32Zm77.62,21.54-1.14-.47,1.14.47ZM355.7,185.94l-1.82-.51h0l1.82.51Zm-164.34-6L186,176.85a364.15,364.15,0,0,0-39.87,8.58l17.94,10.46ZM7.25,320.7c0,.22,0,.44.07.66,0-.22-.05-.44-.07-.66Zm4.16,20c.13.4.27.79.42,1.19-.14-.39-.26-.78-.39-1.17Zm-4-18.49h0l-.09-.82C7.35,321.63,7.38,321.91,7.4,322.18Zm40.74-58.71L30.2,253a112.41,112.41,0,0,0-14.7,23.25l5.34,3.12ZM15.48,276.25l-.56,1.25c.19-.42.39-.82.58-1.24Zm61.3-29.48L51.33,231.93a150,150,0,0,0-20.25,20l18.41,10.73ZM7.25,306.43h0l.15-1.49Zm40.89-9.57L20.84,281l-9.43,5.5a86.87,86.87,0,0,0-4,18.49l13.44,7.84ZM14.92,277.5c-1,2.31-2,4.64-2.81,7l7.38-4.31Zm-3.51,8.95h0c.22-.66.46-1.32.7-2C11.87,285.13,11.63,285.79,11.41,286.45Zm39.9-54.53h0l.76-.64Zm42.66-27Zm14.41-6.53h0l.31-.14Zm-1.6,30.89,27.29-15.91-25.68-15Q101,201.47,94,204.92l-14.49,8.45Zm28.64-16.7,27.3-15.91-18.41-10.73A313.41,313.41,0,0,0,110,197.74ZM7.25,306.43a82.93,82.93,0,0,0,0,14.27l12.24-7.14ZM78.13,246l27.3-15.91-27.3-15.91L63.64,222.6q-5.91,4.11-11.2,8.4Zm-47.06,6-.65.79.66-.78Zm47.09-38.58h0l0,0,0,0Zm68-27.93-1.83.51h0l1.82-.51ZM63.64,222.6Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Cloud--inject-5",
    d: "M394.8,69.8l9.69,5.6a11.13,11.13,0,0,1-.08-1.28V71.31c0-5,3.51-7,7.84-4.53a15.32,15.32,0,0,1,4.67,4.5c.71-6.29,5.64-8.63,11.63-5.17,6.48,3.74,11.73,12.83,11.73,20.31v4.2a11,11,0,0,1-1,4.87l8.06,4.65a9.6,9.6,0,0,1,4.34,7.53c0,2.77-1.94,3.89-4.34,2.51L394.8,79.85a9.63,9.63,0,0,1-4.35-7.54C390.45,69.54,392.4,68.42,394.8,69.8Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--cloud--inject-5",
    d: "M105.2,57.39,95.51,63a11.45,11.45,0,0,0,.08-1.29V58.89c0-5-3.51-7-7.84-4.52a15.17,15.17,0,0,0-4.67,4.49c-.71-6.29-5.64-8.63-11.63-5.17C65,57.43,59.72,66.52,59.72,74v4.2a11,11,0,0,0,1,4.87l-8.06,4.65a9.61,9.61,0,0,0-4.34,7.53c0,2.77,1.94,3.9,4.34,2.51L105.2,67.43a9.62,9.62,0,0,0,4.35-7.53C109.55,57.13,107.6,56,105.2,57.39Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--cloud--inject-5",
    d: "M159.73,54.45l-7.13,4.11a7.54,7.54,0,0,0,.06-.94V55.55c0-3.67-2.58-5.16-5.76-3.32a11.17,11.17,0,0,0-3.43,3.3c-.52-4.62-4.15-6.34-8.55-3.8-4.76,2.75-8.62,9.43-8.62,14.93v3.09a8.18,8.18,0,0,0,.73,3.57l-5.91,3.42a7.06,7.06,0,0,0-3.2,5.54c0,2,1.43,2.86,3.2,1.84l38.61-22.29a7.09,7.09,0,0,0,3.2-5.54C162.93,54.25,161.49,53.43,159.73,54.45Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-5",
    d: "M365.86,435.18l-28.39-16.39c-2.12-1.23-2.12-3.21,0-4.44l106.37-61.42a8.54,8.54,0,0,1,7.69,0l28.39,16.39c2.12,1.23,2.12,3.22,0,4.44L432,401.44l-58.44,33.74A8.47,8.47,0,0,1,365.86,435.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M144.72,423.52l63.64,36.78a5.19,5.19,0,0,0,4.7,0l40.34-23.19,22.39-12.93c1.3-.75,1.3-2,0-2.71l-63.64-36.78a5.19,5.19,0,0,0-4.7,0l-62.73,36.12C143.42,421.56,143.42,422.77,144.72,423.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M422.73,331.92,214.57,210.56a13.34,13.34,0,0,0-12.1,0L89.12,276.5c-4.52,2.63-4.52,6.94,0,9.56L295.84,406.58a11.69,11.69,0,0,0,10.66,0L422.73,339C426.06,337,426.06,333.86,422.73,331.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M73.47,262.53,45.33,246.27c-.53-.31-.53-.8,0-1.1l64.08-37a2.12,2.12,0,0,1,1.9,0l28.15,16.26a.58.58,0,0,1,0,1.1l-64.09,37A2.12,2.12,0,0,1,73.47,262.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M123.43,414.22a12,12,0,0,1-6-1.5l-103.1-60.1-.09-.07a6,6,0,0,1-3.17-5.17,6.16,6.16,0,0,1,3.37-5.22l68-39.65a12.86,12.86,0,0,1,12,0l103,60.06a6.18,6.18,0,0,1,3.36,5.23,6,6,0,0,1-3,5,4.38,4.38,0,0,1-.42.28l-51.46,30-16.51,9.63a12.09,12.09,0,0,1-6,1.49Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bag--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--light-bag--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.7,107.33c-2.13-1.23-4.74-1.08-7.36.43-6,3.49-10.94,13.55-10.94,22.45v21a.95.95,0,0,0,1.9,0v-21c0-8.29,4.48-17.61,10-20.8,2-1.17,3.92-1.32,5.46-.43,2.27,1.31,3.58,4.64,3.58,9.14V139a1,1,0,1,0,1.9,0V118.12C97.23,112.93,95.58,109,92.7,107.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.55 224.66 128.68 123.88 116.86 117.08 111.34 211.25 134.55 224.66",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.55 224.66 128.68 123.88 116.86 117.08 111.34 211.25 134.55 224.66",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.8 151.17 52.29 245.34 111.34 211.25 116.86 117.08 57.8 151.17",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.8 151.17 52.29 245.34 111.34 211.25 116.86 117.08 57.8 151.17",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.8 151.17 52.29 245.34 111.34 211.25 116.86 117.08 57.8 151.17",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.8 151.17 69.63 157.97 75.5 258.75 52.29 245.34 57.8 151.17",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.8 151.17 69.63 157.97 75.5 258.75 52.29 245.34 57.8 151.17",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.5 258.75 65.21 243.49 63.9 196.8 62.85 242.15 52.29 245.34 75.5 258.75",
    style: {
      fill: "#FB923C",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.68,123.88,69.63,158,75.5,258.75l59.05-34.09ZM87.21,160.33c-1.17.66-2.11.11-2.11-1.24a4.65,4.65,0,0,1,2.11-3.65c1.16-.67,2.11-.12,2.11,1.24A4.64,4.64,0,0,1,87.21,160.33Zm20.93-12.18c-1.17.67-2.11.11-2.11-1.23a4.63,4.63,0,0,1,2.11-3.65c1.16-.68,2.11-.12,2.11,1.23A4.63,4.63,0,0,1,108.14,148.15Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.68,123.88,69.63,158,75.5,258.75l59.05-34.09ZM87.21,160.33c-1.17.66-2.11.11-2.11-1.24a4.65,4.65,0,0,1,2.11-3.65c1.16-.67,2.11-.12,2.11,1.24A4.64,4.64,0,0,1,87.21,160.33Zm20.93-12.18c-1.17.67-2.11.11-2.11-1.23a4.63,4.63,0,0,1,2.11-3.65c1.16-.68,2.11-.12,2.11,1.23A4.63,4.63,0,0,1,108.14,148.15Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.56,114c-2.13-1.23-4.74-1.07-7.36.44-6,3.48-10.94,13.55-10.94,22.44v21a1,1,0,1,0,1.9,0v-21c0-8.28,4.48-17.61,10-20.79,2-1.18,3.92-1.33,5.46-.44,2.27,1.31,3.58,4.65,3.58,9.15v20.87a.95.95,0,0,0,1.9,0V124.84C109.09,119.64,107.44,115.7,104.56,114Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mobile--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--mobile--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.41,194.39,421.32,309.75c6,3.53,6,7.53,6,11.12s-1.6,8.57-6,11.12l-112,65.31a17.36,17.36,0,0,1-15.84,0L95.55,281.94c-4.38-2.55-5.37-6.83-5.37-10.42s1-9.27,5.37-11.82l112-65.31A14.78,14.78,0,0,1,223.41,194.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.63,199.33l-115.2,67.16L301.37,382.41v16.81a16,16,0,0,1-7.92-1.92L95.55,281.94c-4.38-2.55-5.37-6.83-5.37-10.42s1-9.27,5.37-11.82l112-65.31a15,15,0,0,1,10.06-2.13v7.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.28,310.7,221.79,195.57a13.86,13.86,0,0,0-12.6,0L99.83,259.33c-4.7,2.74-4.7,7.23,0,10l196,114.25a12.22,12.22,0,0,0,11.11,0l112.35-65.5C422.75,316,422.75,312.72,419.28,310.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.45,311.58a6.76,6.76,0,0,1,3.12,5.23,2,2,0,0,1-.86,1.84c-.38.21-1.8,1.07-2.19,1.28a2.26,2.26,0,0,1-2.25-.26l-19.14-11.16a6.74,6.74,0,0,1-3.13-5.23,2,2,0,0,1,.79-1.8c.39-.24,1.87-1.1,2.26-1.32a2.26,2.26,0,0,1,2.25.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.27,312.85l-19.14-11.16c-1.73-1-3.13-.3-3.13,1.59a6.74,6.74,0,0,0,3.13,5.23l19.14,11.16c1.72,1,3.12.3,3.12-1.59A6.76,6.76,0,0,0,164.27,312.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.94,292a6.79,6.79,0,0,1,3.12,5.24,1.93,1.93,0,0,1-.86,1.83c-.37.21-1.79,1.07-2.18,1.29a2.28,2.28,0,0,1-2.26-.26L111.62,289a6.79,6.79,0,0,1-3.12-5.23,2,2,0,0,1,.79-1.8c.38-.25,1.86-1.11,2.25-1.33a2.28,2.28,0,0,1,2.26.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.76,293.31l-19.14-11.16c-1.72-1-3.12-.29-3.12,1.6a6.79,6.79,0,0,0,3.12,5.23l19.14,11.16c1.73,1,3.13.29,3.13-1.59A6.77,6.77,0,0,0,130.76,293.31Z",
    style: {
      fill: "#37474f"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.94,203.6,408.52,309.45c3.31,1.93,3.32,5.08,0,7L306.88,375.72a13.1,13.1,0,0,1-12,0L111.69,268.94c-2.69-1.57-3.21-3.93-1.52-5.8l.41-.43a8,8,0,0,1,1.11-.77l28.59-16.67,1.86-1.09a4.09,4.09,0,0,1,3.73,0,4.21,4.21,0,0,0,3.86-.08l33.32-19.42c1.09-.64,1.16-1.65.13-2.25s-1-1.45-.2-2.06l.19-.12,28-16.3.59-.35A16.72,16.72,0,0,1,226.94,203.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M145.87,248.5a4.06,4.06,0,0,0-3.73,0l-1.86,1.08-28.59,16.67a8,8,0,0,0-1.11.78l-.41.42c0,.05-.07.11-.11.15a6.19,6.19,0,0,0,1.63,1.34L294.88,375.72a13.1,13.1,0,0,0,12,0l101.65-59.26a6.16,6.16,0,0,0,1.62-1.34,5.9,5.9,0,0,0-1.63-1.35L226.94,207.92a16.72,16.72,0,0,0-15.21,0l-.59.35L183.9,224.14s0,3.27,0,3.66a1.48,1.48,0,0,1-.86,1.2l-33.32,19.42A4.24,4.24,0,0,1,145.87,248.5Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.87,248.5a4.06,4.06,0,0,0-3.73,0l-1.86,1.08-28.59,16.67a8,8,0,0,0-1.11.78l-.41.42c0,.05-.07.11-.11.15a6.19,6.19,0,0,0,1.63,1.34L294.88,375.72a13.1,13.1,0,0,0,12,0l101.65-59.26a6.16,6.16,0,0,0,1.62-1.34,5.9,5.9,0,0,0-1.63-1.35L226.94,207.92a16.72,16.72,0,0,0-15.21,0l-.59.35L183.9,224.14s0,3.27,0,3.66a1.48,1.48,0,0,1-.86,1.2l-33.32,19.42A4.24,4.24,0,0,1,145.87,248.5Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.27,263.43a.33.33,0,0,1-.14-.06l-.49-.33-1.27.74a.17.17,0,0,1-.2,0l-.18-.12-.08-.07a.34.34,0,0,1,0-.08l-.4-2v-.08l.07-.07.18-.1a.23.23,0,0,1,.16,0,.26.26,0,0,1,.15.06l1.7,1.15.28-.16a.21.21,0,0,1,.15,0,.29.29,0,0,1,.15.06l.11.08s.08.06.08.09,0,.06-.08.09l-.28.16.49.33c.05,0,.08.07.08.1s0,.06-.09.09l-.21.12A.3.3,0,0,1,140.27,263.43Zm-1-.72-1.21-.82.29,1.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.48,262.35a3,3,0,0,1-1.49-.55c-.48-.32-.73-.65-.75-1s.21-.62.66-.88a2.44,2.44,0,0,1,.57-.26,2.31,2.31,0,0,1,.56-.11.13.13,0,0,1,.09,0,.09.09,0,0,1,0,.05l.1.21s0,0,0,0l-.07,0a1.94,1.94,0,0,0-.81.27c-.3.18-.45.38-.44.6s.2.47.57.72a2.26,2.26,0,0,0,1.09.42,1.64,1.64,0,0,0,1-.22,2,2,0,0,0,.28-.2.72.72,0,0,0,.17-.2l-.79-.53-.53.31a.28.28,0,0,1-.15,0l-.15-.06-.11-.08c-.05,0-.08-.07-.08-.1s0-.05.08-.08l.85-.49a.26.26,0,0,1,.17-.05.47.47,0,0,1,.17.07l1.13.77a.3.3,0,0,1,.08.07.06.06,0,0,1,0,.07,1.49,1.49,0,0,1-.75.75A2.5,2.5,0,0,1,141.48,262.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,256a.49.49,0,0,1-.06.89,1.44,1.44,0,0,1-1.41,0,.48.48,0,0,1,0-.89A1.44,1.44,0,0,1,152,256Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.46,255.21a1.31,1.31,0,0,0-.76,1.64.4.4,0,0,0,.41.19h0c.24,0,.41-.16.35-.31a.93.93,0,0,1,.53-1.16,2.74,2.74,0,0,1,1.88-.24c.22,0,.47-.05.51-.2h0c0-.12-.08-.23-.26-.27A3.9,3.9,0,0,0,149.46,255.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.37,254.47a2.18,2.18,0,0,0-1.29,2.44c0,.13.21.22.42.21h0c.23,0,.4-.15.35-.29a1.77,1.77,0,0,1,1.05-2,5,5,0,0,1,3.24-.51c.23,0,.45-.06.49-.2h0c0-.13-.1-.25-.3-.28A6.19,6.19,0,0,0,148.37,254.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.64 271.83 125.7 271.2 127.05 270.41 127.99 271.05 126.64 271.83",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.66 270.65 126.79 269.38 128.14 268.59 130.02 269.86 128.66 270.65",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.69 269.47 127.88 267.56 129.23 266.77 132.04 268.68 130.69 269.47",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.72 268.29 128.97 265.74 130.32 264.95 134.07 267.5 132.72 268.29",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.58,216.76a1.23,1.23,0,0,0-.77.11l-5.06,2.94c-.33.19-.27.55.14.82l1.7,1.16a1.83,1.83,0,0,0,.84.29,1.72,1.72,0,0,0,.39,0,1,1,0,0,0,.38-.12l5.06-2.94c.33-.19.27-.55-.13-.82l-1.71-1.16A1.83,1.83,0,0,0,214.58,216.76Zm-3.18,5.13a.87.87,0,0,1-.36-.15l-1.71-1.15c-.29-.2-.34-.49-.1-.63l5.06-2.94a.48.48,0,0,1,.2-.07h.13a1,1,0,0,1,.35.14l1.71,1.16c.3.2.34.49.1.63l-5.06,2.94A.51.51,0,0,1,211.4,221.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.49,219.6l2,1.37-.79.46a.35.35,0,0,1-.26,0l-1.5-1c-.22-.15-.25-.37-.08-.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.86 219.39 211.81 218.83 213.82 220.2 212.87 220.75 210.86 219.39",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.18 218.62 213.13 218.07 215.15 219.44 214.19 219.99 212.18 218.62",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.58,217.39l1.45,1c.27.18.19.43-.2.66l-.32.19-2-1.37.75-.44A.43.43,0,0,1,214.58,217.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.62,217c.14-.09.54,0,.89.28l.31.21c.35.24.53.5.4.59l-.25.16-1.6-1.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.63 225.39 205.63 221.9 207.42 225.03 204.86 224.2 201.63 225.39",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.51,237.5l15.28-8.91a3.54,3.54,0,0,1,3.2-.06c.85.5.81,1.34-.11,1.87l-15.27,8.9a3.51,3.51,0,0,1-3.2.06C147.56,238.86,147.6,238,148.51,237.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,223.66a4.07,4.07,0,0,1,3.72,0,1.15,1.15,0,0,1,0,2.17,4.13,4.13,0,0,1-3.72,0A1.15,1.15,0,0,1,171,223.66Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shine--inject-5",
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "305.52 249.41 276.85 232.69 251.49 350.43 280.16 367.15 305.52 249.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.1,343.22l25.35-117.74L226.94,203.6a16.72,16.72,0,0,0-15.21,0l-.59.35-16.85,9.82-19.77,91.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.46 266.29 369 286.42 355.93 347.13 311.47 373.05 334.46 266.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.52,316.46l-15.68,9.15,4.84-22.47,10.83,6.31C411.83,311.39,411.84,314.54,408.52,316.46Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--credit-card--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Card--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.86,407.75l68-39.64a3.25,3.25,0,0,0,1.84-2.84c0-1,0-4.87,0-4.87s-1.82,2.63-1.85,2.64l-51.51,30-16.51,9.63a9.81,9.81,0,0,1-9,0l-103-60s-1.75-2.06-1.79-2.08-.09,3.59,0,4.79a3.16,3.16,0,0,0,1.83,2.37l103,60A9.78,9.78,0,0,0,127.86,407.75Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.86,407.75l68-39.64a3.25,3.25,0,0,0,1.84-2.84c0-1,0-4.87,0-4.87s-1.82,2.63-1.85,2.64l-51.51,30-16.51,9.63a9.81,9.81,0,0,1-9,0l-103-60s-1.75-2.06-1.79-2.08-.09,3.59,0,4.79a3.16,3.16,0,0,0,1.83,2.37l103,60A9.78,9.78,0,0,0,127.86,407.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.58,408.77v-5.08a8.31,8.31,0,0,0,3.26-1l16.51-9.63,51.51-30s1.83-2.61,1.85-2.64,0,3.82,0,4.87a3.25,3.25,0,0,1-1.84,2.84l-68,39.64A8.59,8.59,0,0,1,124.58,408.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.26,374.47h0v5.06l19.59-11.42a3.25,3.25,0,0,0,1.84-2.84c0-1,0-4.87,0-4.87s-1.82,2.63-1.85,2.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.86,363a.3.3,0,0,0,.1-.07c2.36-1.42,2.32-3.73-.1-5.15l-103-60a9.84,9.84,0,0,0-9,0l-68,39.65c-2.45,1.42-2.47,3.72-.1,5.15l.1.07,103,60a9.81,9.81,0,0,0,9,0l16.51-9.63Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.24,343.48l-2.77-1.6c-1.23-.75-2-1-1.94-2,.13-.58.9-1.1,1.44-1.4,22.47-13.3,44.85-26.74,67-40.67l-68,39.65c-2.45,1.42-2.47,3.72-.1,5.15l.1.07,103,60Q97.23,389,75.3,375.92C58.42,365.77,37.36,353.39,20.24,343.48Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.33,309.22l19.59-11.43a.39.39,0,0,1,.13-.06,9.84,9.84,0,0,1,8.83.06l103,60c2.46,1.44,2.48,3.78,0,5.22l-19.59,11.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.05,334.59l-2-1.17a.26.26,0,0,1-.15-.18.16.16,0,0,1,.1-.17.56.56,0,0,1,.3-.07.8.8,0,0,1,.32.09l.66.39,2.88-1.68a.34.34,0,0,0,.21-.35.55.55,0,0,0-.29-.37h0a.25.25,0,0,1-.15-.19c0-.07,0-.12.1-.17a.48.48,0,0,1,.3-.06.66.66,0,0,1,.32.08h0a1.06,1.06,0,0,1,.6.75.69.69,0,0,1-.42.7L48,333.86l.66.39a.27.27,0,0,1,.15.19.17.17,0,0,1-.11.17.48.48,0,0,1-.3.06A.62.62,0,0,1,48.05,334.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.09,336.1l-1.33-.78a1.41,1.41,0,0,0-.64-.17,1.11,1.11,0,0,0-.6.12l-.43.25a.1.1,0,0,0-.05.09.11.11,0,0,0,.07.09l2.83,1.65a.25.25,0,0,1,.15.19.17.17,0,0,1-.11.17.48.48,0,0,1-.3.06.57.57,0,0,1-.32-.09L50,335.75a.27.27,0,0,1-.15-.19c0-.07,0-.12.11-.17l.86-.5a2.14,2.14,0,0,1,1.2-.25,2.77,2.77,0,0,1,1.28.35l1.32.77a1.36,1.36,0,0,0,.64.18,1.13,1.13,0,0,0,.61-.12l.57-.34a.34.34,0,0,0,.21-.35c0-.14-.12-.26-.3-.37L55.06,334a1.44,1.44,0,0,0-.64-.17,1.11,1.11,0,0,0-.6.12.56.56,0,0,1-.3.07.75.75,0,0,1-.31-.09.28.28,0,0,1-.16-.19.17.17,0,0,1,.11-.17,2.14,2.14,0,0,1,1.2-.25,2.73,2.73,0,0,1,1.27.35l1.33.77a1.1,1.1,0,0,1,.61.75.71.71,0,0,1-.43.7l-.57.33a2.14,2.14,0,0,1-1.2.25A2.8,2.8,0,0,1,54.09,336.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.44,340.13l-.29.17a2.22,2.22,0,0,1-1.2.25,2.77,2.77,0,0,1-1.28-.35l-1.33-.78a1.08,1.08,0,0,1-.6-.74.7.7,0,0,1,.43-.7.45.45,0,0,1,.3-.06.62.62,0,0,1,.31.08c.1.06.15.12.15.19a.18.18,0,0,1-.1.18.34.34,0,0,0-.21.35.55.55,0,0,0,.3.37l1.33.77a1.29,1.29,0,0,0,.63.18,1,1,0,0,0,.6-.13l.29-.16c.16-.1.23-.21.21-.35a.51.51,0,0,0-.3-.38l-.33-.19a.28.28,0,0,1-.15-.18.19.19,0,0,1,.1-.18.48.48,0,0,1,.3-.06.6.6,0,0,1,.33.09l.33.19a1.29,1.29,0,0,0,.64.17,1.11,1.11,0,0,0,.6-.12l.28-.17a.34.34,0,0,0,.21-.35c0-.14-.11-.26-.3-.37l-1.32-.77a1.36,1.36,0,0,0-.64-.18,1,1,0,0,0-.6.13.67.67,0,0,1-.3.06.8.8,0,0,1-.32-.09.27.27,0,0,1-.15-.19c0-.06,0-.12.11-.17a2.1,2.1,0,0,1,1.2-.25,2.73,2.73,0,0,1,1.27.35l1.33.78a1.05,1.05,0,0,1,.6.74.72.72,0,0,1-.42.7l-.29.17a2,2,0,0,1-.6.2,3.35,3.35,0,0,1-.71,0,.59.59,0,0,1-.06.41A.9.9,0,0,1,60.44,340.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.29,344a.8.8,0,0,1-.32-.09.26.26,0,0,1-.15-.18.18.18,0,0,1,.11-.18l1.59-.93a2.84,2.84,0,0,1-.82-.29l-1.32-.78a1.07,1.07,0,0,1-.61-.74.7.7,0,0,1,.43-.7l1.44-.84a.6.6,0,0,1,.29-.06.57.57,0,0,1,.32.09.26.26,0,0,1,.15.18.17.17,0,0,1-.1.18l-1.44.84a.34.34,0,0,0-.21.35.55.55,0,0,0,.3.37l1.33.77a1.3,1.3,0,0,0,.64.18,1,1,0,0,0,.6-.13l1.43-.83a.56.56,0,0,1,.3-.07.8.8,0,0,1,.32.09.27.27,0,0,1,.15.19.17.17,0,0,1-.1.17l-4,2.35A.61.61,0,0,1,64.29,344Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.62,346.56a.09.09,0,0,0-.05.09s0,.06.07.09l1.83,1.07a1,1,0,0,1,.6.74.72.72,0,0,1-.42.7l-.58.33a2.12,2.12,0,0,1-1.2.25,2.73,2.73,0,0,1-1.27-.35l-1.33-.77a1,1,0,0,1-.6-.75.69.69,0,0,1,.42-.7.67.67,0,0,1,.3-.06.8.8,0,0,1,.32.09.27.27,0,0,1,.15.19c0,.06,0,.12-.11.17a.37.37,0,0,0-.21.35.53.53,0,0,0,.3.37l1.33.78a1.44,1.44,0,0,0,.64.17,1.11,1.11,0,0,0,.6-.12l.57-.34a.34.34,0,0,0,.21-.35c0-.14-.11-.26-.3-.37l-2-1.16a.55.55,0,0,1-.3-.37.36.36,0,0,1,.22-.35l1.43-.84a.48.48,0,0,1,.3-.06.57.57,0,0,1,.32.09l3.32,1.93a.25.25,0,0,1,.15.19c0,.07,0,.12-.1.17a.49.49,0,0,1-.31.06.75.75,0,0,1-.31-.09l-2.82-1.64a.29.29,0,0,0-.16,0,.22.22,0,0,0-.16,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.45,350.13l1.33.77a1,1,0,0,1,.6.75.69.69,0,0,1-.42.7l-.57.33a2.15,2.15,0,0,1-1.21.25,2.69,2.69,0,0,1-1.28-.36l-1.32-.77a1.07,1.07,0,0,1-.61-.74.7.7,0,0,1,.43-.7L79.7,349a2.1,2.1,0,0,1,1.2-.25,2.73,2.73,0,0,1,1.27.35l1.33.77a1.1,1.1,0,0,1,.61.75.7.7,0,0,1-.43.7.48.48,0,0,1-.3.06.57.57,0,0,1-.32-.09.26.26,0,0,1-.15-.18A.18.18,0,0,1,83,351a.33.33,0,0,0,.21-.35.55.55,0,0,0-.3-.37l-1.33-.77a1.33,1.33,0,0,0-.64-.18,1,1,0,0,0-.6.13l-.73.42A2.58,2.58,0,0,1,80.45,350.13Zm-2.39.62a.33.33,0,0,0-.21.34.54.54,0,0,0,.3.38l1.33.77a1.33,1.33,0,0,0,.64.18,1,1,0,0,0,.6-.13l.58-.33a.37.37,0,0,0,.21-.35.55.55,0,0,0-.31-.38l-1.33-.77a1.4,1.4,0,0,0-.63-.17,1.11,1.11,0,0,0-.6.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1,354.76l-3.93.55h-.46l-.09,0a.09.09,0,0,1-.07,0,.35.35,0,0,1-.17-.17c0-.07,0-.13.12-.19a1.43,1.43,0,0,1,.46-.07c1.26-.18,2.48-.36,3.64-.55a1.5,1.5,0,0,0,.35-.09l.28-.11.09-.05c.16-.1.23-.21.21-.35a.48.48,0,0,0-.3-.37l-.66-.39-.33-.2L85.91,352a.27.27,0,0,1-.15-.19c0-.06,0-.12.11-.17a.5.5,0,0,1,.29-.06.6.6,0,0,1,.33.09l1.32.77.33.19.67.39a1,1,0,0,1,.6.74.71.71,0,0,1-.42.7,2.36,2.36,0,0,1-.47.2A2.61,2.61,0,0,1,88.1,354.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.28,358.7l-.28.17a2.24,2.24,0,0,1-1.21.24,2.54,2.54,0,0,1-1.27-.35L88.19,358a1.05,1.05,0,0,1-.6-.74.7.7,0,0,1,.42-.7l.29-.17a1.77,1.77,0,0,1,.6-.21,2.78,2.78,0,0,1,.71,0,.61.61,0,0,1,.06-.42,1,1,0,0,1,.35-.35l.29-.16a2.14,2.14,0,0,1,1.2-.25,2.77,2.77,0,0,1,1.28.35l1.33.77a1.11,1.11,0,0,1,.6.75.71.71,0,0,1-.43.7l-.28.17a2,2,0,0,1-.6.2,2.86,2.86,0,0,1-.72,0,.67.67,0,0,1,0,.42A.87.87,0,0,1,92.28,358.7Zm1.35-1.56a.34.34,0,0,0,.21-.35.55.55,0,0,0-.3-.37l-1.33-.78a1.4,1.4,0,0,0-.63-.17,1.09,1.09,0,0,0-.6.12l-.29.17a.34.34,0,0,0-.21.35.5.5,0,0,0,.3.37l1.32.78a1.48,1.48,0,0,0,.64.17,1.11,1.11,0,0,0,.6-.12Zm-2,1.17a.34.34,0,0,0,.21-.35.55.55,0,0,0-.3-.37l-1.33-.77a1.29,1.29,0,0,0-.63-.18,1,1,0,0,0-.6.13l-.29.16c-.16.1-.23.21-.21.35a.48.48,0,0,0,.3.37l1.32.78a1.35,1.35,0,0,0,.64.17,1.11,1.11,0,0,0,.6-.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.13,365l-1.32-.77a1,1,0,0,1-.6-.74.67.67,0,0,1,.42-.7.56.56,0,0,1,.3-.07.8.8,0,0,1,.32.09.29.29,0,0,1,.15.19.17.17,0,0,1-.11.17c-.15.1-.23.21-.21.35a.53.53,0,0,0,.3.37l1.33.78a1.59,1.59,0,0,0,.64.18,1,1,0,0,0,.6-.13l.73-.42a2.58,2.58,0,0,1-.82-.3l-1.33-.78a1,1,0,0,1-.6-.74.7.7,0,0,1,.42-.7l.58-.33a2.14,2.14,0,0,1,1.2-.25,2.73,2.73,0,0,1,1.27.35l1.33.77a1.1,1.1,0,0,1,.61.75.7.7,0,0,1-.43.7l-2.29,1.34a2.15,2.15,0,0,1-1.21.25A2.69,2.69,0,0,1,100.13,365Zm4.12-1.62a.34.34,0,0,0,.21-.35c0-.14-.12-.26-.3-.37l-1.33-.78a1.44,1.44,0,0,0-.64-.17,1.11,1.11,0,0,0-.6.12l-.57.34a.36.36,0,0,0-.22.35.54.54,0,0,0,.31.37l1.32.77a1.36,1.36,0,0,0,.64.18,1.13,1.13,0,0,0,.61-.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.11,367.85l-2-1.16a.26.26,0,0,1-.15-.18.18.18,0,0,1,.1-.18.68.68,0,0,1,.62,0l.66.38,2.88-1.67a.34.34,0,0,0,.21-.35.56.56,0,0,0-.29-.37h0a.28.28,0,0,1-.16-.19.18.18,0,0,1,.11-.17.56.56,0,0,1,.3-.07.8.8,0,0,1,.32.09h0a1,1,0,0,1,.6.74.69.69,0,0,1-.42.71L105,367.13l.66.39a.26.26,0,0,1,.15.18.18.18,0,0,1-.11.18.48.48,0,0,1-.3.06A.75.75,0,0,1,105.11,367.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.42,370.37l-1.32-.77a1.06,1.06,0,0,1-.6-.75.69.69,0,0,1,.42-.7l2.3-1.34a2.1,2.1,0,0,1,1.2-.24,2.61,2.61,0,0,1,1.27.35l1.33.77a1,1,0,0,1,.6.74.68.68,0,0,1-.42.7l-2.3,1.34a2.14,2.14,0,0,1-1.2.25A2.8,2.8,0,0,1,109.42,370.37Zm-.75-1.11L110,370a1.38,1.38,0,0,0,.39.15l.44-2.95-2.25,1.31a.34.34,0,0,0-.21.35A.55.55,0,0,0,108.67,369.26Zm4.78-1.24-1.33-.77a1.38,1.38,0,0,0-.39-.14l-.44,2.95,2.24-1.31a.37.37,0,0,0,.22-.35A.54.54,0,0,0,113.45,368Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.39,373.27l-2-1.16a.29.29,0,0,1-.15-.19.17.17,0,0,1,.11-.17.48.48,0,0,1,.3-.06.66.66,0,0,1,.32.08l.66.39,2.87-1.68a.35.35,0,0,0,.22-.34.54.54,0,0,0-.29-.37h0a.25.25,0,0,1-.16-.18.18.18,0,0,1,.11-.18.56.56,0,0,1,.3-.06.57.57,0,0,1,.32.09h0a1,1,0,0,1,.6.74.68.68,0,0,1-.42.7l-2.87,1.68.66.38a.29.29,0,0,1,.15.19.17.17,0,0,1-.11.17.48.48,0,0,1-.3.06A.66.66,0,0,1,114.39,373.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.68,378.68l-2-1.16a.26.26,0,0,1-.15-.18.18.18,0,0,1,.11-.18.68.68,0,0,1,.62,0l.66.38,2.87-1.67a.36.36,0,0,0,.22-.35.56.56,0,0,0-.29-.37h0a.29.29,0,0,1-.15-.19.17.17,0,0,1,.11-.17.56.56,0,0,1,.3-.07.8.8,0,0,1,.32.09h0a1,1,0,0,1,.6.75.7.7,0,0,1-.42.7L123.59,378l.67.39a.26.26,0,0,1,.15.18.18.18,0,0,1-.11.18.48.48,0,0,1-.3.06A.8.8,0,0,1,123.68,378.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.73,380.19l-1.33-.77a1.32,1.32,0,0,0-.64-.17,1.11,1.11,0,0,0-.6.12l-.43.25a.08.08,0,0,0,0,.09.12.12,0,0,0,.07.09l2.83,1.65c.09.05.14.11.14.18a.17.17,0,0,1-.1.18.48.48,0,0,1-.3.06.66.66,0,0,1-.32-.09l-3.32-1.93a.29.29,0,0,1-.15-.19.16.16,0,0,1,.1-.17l.87-.51a2.19,2.19,0,0,1,1.2-.24,2.61,2.61,0,0,1,1.27.35l1.33.77a1.33,1.33,0,0,0,.64.18,1,1,0,0,0,.6-.13l.58-.33a.34.34,0,0,0,.21-.35.55.55,0,0,0-.31-.38l-1.32-.77a1.35,1.35,0,0,0-.64-.17,1.11,1.11,0,0,0-.6.12.48.48,0,0,1-.3.06.57.57,0,0,1-.32-.09.26.26,0,0,1-.15-.18.18.18,0,0,1,.1-.18,2.24,2.24,0,0,1,1.21-.24,2.64,2.64,0,0,1,1.27.35l1.33.77a1,1,0,0,1,.6.75.69.69,0,0,1-.42.7l-.57.33a2.14,2.14,0,0,1-1.2.25A2.63,2.63,0,0,1,129.73,380.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,384.1l-2-1.16a.27.27,0,0,1-.15-.19.17.17,0,0,1,.1-.17.51.51,0,0,1,.31-.06.66.66,0,0,1,.32.08l.66.39,2.87-1.68a.33.33,0,0,0,.21-.34.49.49,0,0,0-.29-.37h0a.26.26,0,0,1-.15-.18.18.18,0,0,1,.11-.18.56.56,0,0,1,.3-.06.57.57,0,0,1,.32.09h0a1.05,1.05,0,0,1,.6.74.71.71,0,0,1-.42.7l-2.88,1.68.67.38a.29.29,0,0,1,.15.19.2.2,0,0,1-.11.18.67.67,0,0,1-.3.06A.8.8,0,0,1,133,384.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.05,386.55l-.28.17a2.34,2.34,0,0,1-1.21.25,2.76,2.76,0,0,1-1.27-.35l-1.33-.78a1.08,1.08,0,0,1-.6-.74.7.7,0,0,1,.43-.7.43.43,0,0,1,.29-.06.66.66,0,0,1,.32.08.29.29,0,0,1,.15.19.16.16,0,0,1-.1.17c-.16.1-.23.21-.21.35a.5.5,0,0,0,.3.38l1.32.77a1.35,1.35,0,0,0,.64.17,1,1,0,0,0,.6-.12l.29-.17a.34.34,0,0,0,.21-.35.55.55,0,0,0-.3-.37l-.33-.19a.25.25,0,0,1-.15-.19c0-.07,0-.12.1-.17a.48.48,0,0,1,.3-.06.66.66,0,0,1,.32.08l.34.2a1.4,1.4,0,0,0,.63.17,1.11,1.11,0,0,0,.6-.12l.29-.17a.34.34,0,0,0,.21-.35.52.52,0,0,0-.3-.37L140,383.5a1.29,1.29,0,0,0-.63-.18,1.11,1.11,0,0,0-.6.12.57.57,0,0,1-.31.07.85.85,0,0,1-.32-.09.29.29,0,0,1-.15-.19.19.19,0,0,1,.11-.17,2.14,2.14,0,0,1,1.2-.25,2.77,2.77,0,0,1,1.28.35l1.33.78a1.08,1.08,0,0,1,.6.74.71.71,0,0,1-.43.7l-.28.17a2,2,0,0,1-.6.2,3.41,3.41,0,0,1-.72,0,.58.58,0,0,1-.05.41A.87.87,0,0,1,140.05,386.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.6,382.64l-1.16-.68c-.06,0-.09-.07-.09-.11a.08.08,0,0,1,.06-.1.38.38,0,0,1,.36,0l.39.23,1.68-1a.2.2,0,0,0,.12-.2.32.32,0,0,0-.17-.22h0a.14.14,0,0,1-.08-.11.08.08,0,0,1,.06-.1.29.29,0,0,1,.17,0,.38.38,0,0,1,.19.05h0a.63.63,0,0,1,.35.44.41.41,0,0,1-.25.41l-1.67,1,.38.23c.06,0,.09.07.09.11s0,.07-.06.1a.34.34,0,0,1-.18,0A.48.48,0,0,1,108.6,382.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.13,383.52l-.78-.45A.76.76,0,0,0,111,383a.63.63,0,0,0-.35.08l-.25.14s0,0,0,.05a.07.07,0,0,0,0,.06l1.65,1a.19.19,0,0,1,.09.11s0,.07-.07.1a.29.29,0,0,1-.17,0,.42.42,0,0,1-.19-.06l-1.94-1.13c-.05,0-.08-.06-.08-.1a.1.1,0,0,1,.06-.11l.5-.29a1.19,1.19,0,0,1,.7-.14,1.64,1.64,0,0,1,.75.2l.77.45a.89.89,0,0,0,.38.11.63.63,0,0,0,.35-.08l.33-.19c.1-.06.14-.12.13-.21a.3.3,0,0,0-.18-.21l-.78-.46a.84.84,0,0,0-.37-.1.73.73,0,0,0-.35.07.31.31,0,0,1-.17,0,.38.38,0,0,1-.19-.05.19.19,0,0,1-.09-.11.12.12,0,0,1,.06-.1,1.27,1.27,0,0,1,.7-.15,1.61,1.61,0,0,1,.75.21l.77.45a.62.62,0,0,1,.36.44.39.39,0,0,1-.25.4l-.33.2a1.21,1.21,0,0,1-.71.14A1.59,1.59,0,0,1,112.13,383.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.78,386.23l-.78-.45a.76.76,0,0,0-.37-.11.63.63,0,0,0-.35.08l-.25.14s0,0,0,.05a.07.07,0,0,0,0,.06l1.65,1a.14.14,0,0,1,.08.11s0,.07-.06.1a.29.29,0,0,1-.17,0,.53.53,0,0,1-.19,0L114.41,386a.17.17,0,0,1-.09-.1.13.13,0,0,1,.07-.11l.5-.29a1.19,1.19,0,0,1,.7-.14,1.67,1.67,0,0,1,.75.2l.77.45a.76.76,0,0,0,.37.11.66.66,0,0,0,.36-.08l.33-.19a.21.21,0,0,0,.13-.21.3.3,0,0,0-.18-.21l-.78-.46a.84.84,0,0,0-.37-.1.73.73,0,0,0-.35.07.38.38,0,0,1-.36,0,.19.19,0,0,1-.09-.11s0-.07.06-.1a1.27,1.27,0,0,1,.7-.15,1.64,1.64,0,0,1,.75.21l.77.45a.62.62,0,0,1,.36.44.42.42,0,0,1-.25.41l-.34.19a1.18,1.18,0,0,1-.7.14A1.59,1.59,0,0,1,116.78,386.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.48,388.58l-.17.1a1.25,1.25,0,0,1-.7.15,1.6,1.6,0,0,1-.74-.21l-.78-.45a.62.62,0,0,1-.35-.43.4.4,0,0,1,.25-.41.29.29,0,0,1,.17,0,.38.38,0,0,1,.19,0,.19.19,0,0,1,.09.11.11.11,0,0,1-.06.1.21.21,0,0,0-.13.21.3.3,0,0,0,.18.21l.77.46a.89.89,0,0,0,.38.1.75.75,0,0,0,.35-.07l.16-.1c.1-.06.14-.12.13-.21a.3.3,0,0,0-.18-.21l-.19-.12c-.06,0-.09-.06-.09-.1s0-.08.06-.11a.43.43,0,0,1,.36,0l.2.11a.73.73,0,0,0,.37.1.55.55,0,0,0,.35-.07l.17-.1a.2.2,0,0,0,.12-.2.32.32,0,0,0-.17-.22l-.78-.45a.76.76,0,0,0-.37-.1.63.63,0,0,0-.35.07.34.34,0,0,1-.18,0,.35.35,0,0,1-.18-.06c-.06,0-.09-.06-.09-.1a.1.1,0,0,1,.06-.11,1.37,1.37,0,0,1,.7-.14,1.56,1.56,0,0,1,.75.21l.77.45a.59.59,0,0,1,.35.43.41.41,0,0,1-.24.41l-.17.1a1.6,1.6,0,0,1-.35.12,2,2,0,0,1-.42,0,.34.34,0,0,1,0,.24A.45.45,0,0,1,120.48,388.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.38,385.32v0a.12.12,0,0,1,.07-.17l3.36-1.41a.12.12,0,0,1,.17.07.13.13,0,0,1-.07.17l-3.37,1.41A.13.13,0,0,1,112.38,385.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.61,328.08a.94.94,0,0,0,0-1.78c-3.73-2.18-10-5.74-13.75-7.91a3.33,3.33,0,0,0-3,0l-2.41,1.4,16.78,9.71Zm-13.79-4.36-5.06,2.95,4.59,2.65,5-2.94Zm.21,6,5.41,3.12,5-3-5.38-3.13Zm2.32,4.91,2.38-1.39L57,323.55,54.56,325a1,1,0,0,0,0,1.79l13.75,7.9A3.33,3.33,0,0,0,71.35,334.64Zm-3.22-11.32-5.4-3.12-5.06,2.95,5.4,3.13Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.61,328.08a.94.94,0,0,0,0-1.78c-3.73-2.18-10-5.74-13.75-7.91a3.33,3.33,0,0,0-3,0l-2.41,1.4,16.78,9.71Zm-13.79-4.36-5.06,2.95,4.59,2.65,5-2.94Zm.21,6,5.41,3.12,5-3-5.38-3.13Zm2.32,4.91,2.38-1.39L57,323.55,54.56,325a1,1,0,0,0,0,1.79l13.75,7.9A3.33,3.33,0,0,0,71.35,334.64Zm-3.22-11.32-5.4-3.12-5.06,2.95,5.4,3.13Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.93,370.21,95.12,338.84a3.67,3.67,0,0,0-3.38,0l-.24.14a1,1,0,0,0,0,2l53.81,31.37a3.69,3.69,0,0,0,3.39,0l.23-.14A1,1,0,0,0,148.93,370.21Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.93,370.21,95.12,338.84a3.67,3.67,0,0,0-3.38,0l-.24.14a1,1,0,0,0,0,2l53.81,31.37a3.69,3.69,0,0,0,3.39,0l.23-.14A1,1,0,0,0,148.93,370.21Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,310.38a.57.57,0,0,1,.31-.06.5.5,0,0,1,.26.08l.85.49a.24.24,0,0,1,.13.17c0,.06,0,.12-.13.16a5.12,5.12,0,0,1-1.07.38,5.71,5.71,0,0,1-1.34.12,7.06,7.06,0,0,1-1.52-.22,6.36,6.36,0,0,1-1.61-.69,3.66,3.66,0,0,1-1.07-.87,1.53,1.53,0,0,1-.34-.9,1.46,1.46,0,0,1,.31-.89,3.51,3.51,0,0,1,.91-.82c.25-.17.54-.34.86-.53s.62-.35.9-.5a6.91,6.91,0,0,1,1.42-.53,6.51,6.51,0,0,1,1.52-.18,6.26,6.26,0,0,1,1.54.2,5.67,5.67,0,0,1,1.49.62,4.07,4.07,0,0,1,1.18.94,1.68,1.68,0,0,1,.39.89,1.17,1.17,0,0,1-.22.78,2.37,2.37,0,0,1-.64.62.44.44,0,0,1-.28.08.62.62,0,0,1-.29-.08l-.85-.49A.28.28,0,0,1,90,309q0-.09.09-.18a.88.88,0,0,0,.26-.33.64.64,0,0,0,0-.39,1,1,0,0,0-.25-.44,2.38,2.38,0,0,0-.62-.48,3.46,3.46,0,0,0-.83-.34,3.58,3.58,0,0,0-.85-.1,3.3,3.3,0,0,0-.82.11,4.35,4.35,0,0,0-.74.28c-.28.15-.59.32-.91.51s-.6.36-.86.52a2.14,2.14,0,0,0-.49.44.76.76,0,0,0,0,1,1.78,1.78,0,0,0,.59.49,4,4,0,0,0,.81.35,3.77,3.77,0,0,0,.76.15,3,3,0,0,0,.68,0A2.18,2.18,0,0,0,87.4,310.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.06,310.75c.88.51,1.34,1,1.38,1.52s-.28,1-1,1.38a4.4,4.4,0,0,1-1.66.55,4.78,4.78,0,0,1-1.83-.13l-1.15,2.35a.24.24,0,0,1-.08.09.55.55,0,0,1-.46,0l-.89-.52q-.21-.12-.21-.24a.36.36,0,0,1,0-.19l1.07-2.23-1.39-.81L89.43,314a.61.61,0,0,1-.28.06.58.58,0,0,1-.28-.06l-.85-.5a.19.19,0,0,1-.12-.16c0-.07,0-.12.12-.17l6.77-3.95a.5.5,0,0,1,.28-.06.54.54,0,0,1,.29.06Zm-4.87,1,1.51.88a3.25,3.25,0,0,0,1.17.44,1.7,1.7,0,0,0,1.15-.26c.39-.23.54-.45.43-.67a2,2,0,0,0-.75-.67l-1.52-.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,319.47a.19.19,0,0,1,.12.16c0,.07,0,.12-.12.17l-.74.43a.61.61,0,0,1-.28.07.62.62,0,0,1-.29-.07L95,317.55a.19.19,0,0,1-.11-.17.18.18,0,0,1,.11-.16l6.77-4a.54.54,0,0,1,.29-.07.51.51,0,0,1,.28.07l4.52,2.63a.19.19,0,0,1,.11.17.18.18,0,0,1-.11.16l-.75.44a.68.68,0,0,1-.56,0l-3.39-2-1.67,1,3.16,1.84c.08.05.12.1.12.17a.19.19,0,0,1-.12.16l-.74.44a.62.62,0,0,1-.29.07.61.61,0,0,1-.28-.07l-3.16-1.84-1.74,1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.44,318.55a4,4,0,0,1,1.14.9,1.48,1.48,0,0,1,.37.9,1.32,1.32,0,0,1-.32.87,3.81,3.81,0,0,1-.95.84c-.49.32-1,.62-1.55.91a7.23,7.23,0,0,1-1.44.55,5.88,5.88,0,0,1-1.5.19,6.16,6.16,0,0,1-1.52-.2,6.45,6.45,0,0,1-1.52-.65l-2.64-1.54c-.08-.05-.12-.1-.12-.17a.19.19,0,0,1,.12-.16l6.77-3.95a.51.51,0,0,1,.28-.07.52.52,0,0,1,.29.07Zm-1.18,2.69a2.21,2.21,0,0,0,.5-.44.86.86,0,0,0,.17-.49.78.78,0,0,0-.2-.5,2.23,2.23,0,0,0-.66-.53l-1.4-.82L104,321.21l1.46.85a3.55,3.55,0,0,0,.86.37,3.69,3.69,0,0,0,.86.11,3.24,3.24,0,0,0,.82-.11,3.85,3.85,0,0,0,.76-.29A16.55,16.55,0,0,0,110.26,321.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.89,325.62a.18.18,0,0,1-.11-.16.19.19,0,0,1,.11-.17l6.77-4a.54.54,0,0,1,.29-.06.5.5,0,0,1,.28.06l.85.5a.18.18,0,0,1,.11.16.19.19,0,0,1-.11.17l-6.77,3.95a.65.65,0,0,1-.29.06.61.61,0,0,1-.28-.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.88,325.8c.08.05.12.1.12.17a.18.18,0,0,1-.12.16l-.74.44a.61.61,0,0,1-.28.07.62.62,0,0,1-.29-.07l-1.89-1.1-5.74,3.35a.62.62,0,0,1-.57,0l-.85-.5a.19.19,0,0,1-.11-.16c0-.07,0-.12.12-.17l5.74-3.35-1.89-1.1a.19.19,0,0,1-.11-.16.21.21,0,0,1,.11-.17l.75-.43a.59.59,0,0,1,.56,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.84,333.37a.67.67,0,0,1,.31-.05.54.54,0,0,1,.27.07l.84.5a.21.21,0,0,1,.13.16c0,.07,0,.12-.13.17a4.61,4.61,0,0,1-1.07.37,5.17,5.17,0,0,1-1.34.13,7.19,7.19,0,0,1-1.52-.23,6.69,6.69,0,0,1-1.61-.68,3.63,3.63,0,0,1-1.06-.88,1.44,1.44,0,0,1-.35-.89,1.5,1.5,0,0,1,.31-.89,3.71,3.71,0,0,1,.91-.83c.25-.16.54-.34.86-.52l.9-.51a6.88,6.88,0,0,1,1.42-.52,6,6,0,0,1,1.52-.19,6.2,6.2,0,0,1,1.54.2,6.1,6.1,0,0,1,1.5.62,4.15,4.15,0,0,1,1.17,1,1.66,1.66,0,0,1,.39.88,1.17,1.17,0,0,1-.22.78,2.4,2.4,0,0,1-.64.63.51.51,0,0,1-.28.07.65.65,0,0,1-.29-.07l-.84-.5a.25.25,0,0,1-.14-.15.19.19,0,0,1,.09-.19.91.91,0,0,0,.27-.32.66.66,0,0,0,0-.39,1,1,0,0,0-.25-.45,2.75,2.75,0,0,0-.61-.47,3.29,3.29,0,0,0-.84-.34,3.13,3.13,0,0,0-.85-.1,2.82,2.82,0,0,0-.81.11,3.52,3.52,0,0,0-.75.28c-.28.15-.58.31-.9.5s-.61.36-.86.53a1.83,1.83,0,0,0-.5.44.75.75,0,0,0-.18.47.81.81,0,0,0,.17.49,1.89,1.89,0,0,0,.59.49,3.59,3.59,0,0,0,.81.36,3.86,3.86,0,0,0,.77.15,2.93,2.93,0,0,0,.67,0A2.18,2.18,0,0,0,126.84,333.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.89,334c.11.07.17.13.16.2a.39.39,0,0,1-.12.24l-4.06,5.36s0,0-.06.05a.51.51,0,0,1-.28.07.49.49,0,0,1-.28-.07l-.76-.44c-.14-.08-.21-.16-.21-.22a.38.38,0,0,1,.06-.17l.72-.94-3.32-1.93-1.61.41-.29,0a.76.76,0,0,1-.38-.12l-.76-.44a.21.21,0,0,1-.11-.17.19.19,0,0,1,.11-.16l.09,0,9.19-2.37a2.61,2.61,0,0,1,.42-.07.63.63,0,0,1,.34.1Zm-4,3,1.84-2.41-4.14,1.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.81,338c.87.51,1.33,1,1.38,1.52s-.28,1-1,1.38a4.2,4.2,0,0,1-1.65.56,4.85,4.85,0,0,1-1.84-.14l-1.14,2.36-.08.08a.47.47,0,0,1-.46,0l-.89-.52c-.14-.08-.21-.16-.22-.24a.38.38,0,0,1,0-.19l1.07-2.22-1.4-.81-2.44,1.42a.51.51,0,0,1-.28.07.54.54,0,0,1-.29-.07l-.84-.49c-.08,0-.12-.1-.12-.17a.19.19,0,0,1,.12-.16l6.77-3.95a.59.59,0,0,1,.56,0Zm-4.88,1,1.52.89a3.22,3.22,0,0,0,1.17.43,1.76,1.76,0,0,0,1.15-.25c.39-.23.54-.45.43-.67a1.78,1.78,0,0,0-.76-.67l-1.51-.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.83,342.13a4,4,0,0,1,1.14.9,1.5,1.5,0,0,1,.38.9,1.39,1.39,0,0,1-.33.87,3.81,3.81,0,0,1-1,.84c-.49.32-1,.62-1.55.91a7.23,7.23,0,0,1-1.44.55,5.83,5.83,0,0,1-1.5.2,5.74,5.74,0,0,1-1.52-.21,6.63,6.63,0,0,1-1.52-.65l-2.64-1.54a.21.21,0,0,1-.11-.17.19.19,0,0,1,.11-.16l6.77-3.95a.54.54,0,0,1,.29-.07.49.49,0,0,1,.28.07Zm-1.17,2.69a2.14,2.14,0,0,0,.49-.44.78.78,0,0,0,.18-.48.8.8,0,0,0-.21-.51,2.17,2.17,0,0,0-.65-.53l-1.41-.82-4.72,2.75,1.46.85a3.31,3.31,0,0,0,1.72.48,2.91,2.91,0,0,0,.83-.11,3.24,3.24,0,0,0,.75-.29A16.74,16.74,0,0,0,150.66,344.82Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cart--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--cart--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M232.26,244.17l-63.83,37c-2.16,1.25-2.16,3.27,0,4.52l73.17,42.29a8.65,8.65,0,0,0,7.82,0l63.83-37c2.16-1.25,2.16-3.27,0-4.52l-73.17-42.27A8.62,8.62,0,0,0,232.26,244.17Z",
    style: {
      fill: "#FB923C",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.32,305.86a14.54,14.54,0,0,1-7.21-1.29L187.28,267.8c-3.85-1.94-8.18-7-8.45-11.75l-2-45.47,3.55-.2,2,45.46c.19,3.25,3.58,7.32,6.5,8.78l63.83,36.77a12.26,12.26,0,0,0,10.71-.62L306,276.25c1-.67,1.6-1.47,1.56-2.14s-.68-1.36-1.75-1.9l-68.33-39.67c-3.85-1.93-8.17-7-8.44-11.76l-.95-25.22,3.55-.2,1,25.22c.18,3.25,3.56,7.32,6.47,8.78L307.39,269c2.28,1.15,3.6,2.88,3.72,4.87s-1,3.92-3.17,5.32l-42.56,24.52A14.5,14.5,0,0,1,258.32,305.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.12,304.57a.33.33,0,0,0,.12.05c-4.16,5.4-10.94,6.94-12.46,6.23-1.23-.56-1.95-2-1-2.9.43-.4,1.17-.81,1.87-1.39,2-1.69,2.71-4.64,2.9-6.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.84,312.91a15.06,15.06,0,0,0-6.74-11.85c-2-1.15-3.74-1.21-5-.39h0l-4.61,2.6,9.67,16.67,4.57-2.59v0C246,316.65,246.82,315.12,246.84,312.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.31,303.78a15,15,0,0,1,6.74,11.84c0,4.35-3.09,6.09-6.84,3.89a15,15,0,0,1-6.74-11.84C228.5,303.32,231.56,301.58,235.31,303.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,310.3c0-1.7,1-2.47,2.32-1.73a5.51,5.51,0,0,1,2.28,4.42c0,1.7-1.05,2.48-2.32,1.73A5.51,5.51,0,0,1,233,310.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.32,297.78s.44,8-3.23,11.09c-.69.57-1.44,1-1.87,1.39-.93.87-.2,2.33,1,2.9,1.79.83,10.91-1.52,14.47-9.4Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.42,310.78a1.52,1.52,0,0,1,.75,1.14c0,.43-.27.62-.66.42a1.49,1.49,0,0,1-.74-1.13C234.74,310.78,235,310.59,235.42,310.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.71,275.54l.11.06c-4.15,5.4-10.92,6.94-12.45,6.22-1.22-.56-2-2-1-2.9.43-.4,1.17-.81,1.86-1.39,2-1.69,2.71-4.64,2.9-6.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.44,283.88A15.09,15.09,0,0,0,189.7,272c-2-1.15-3.74-1.21-5-.38h0l-4.61,2.59,9.66,16.67,4.58-2.59h0C195.61,287.62,196.42,286.09,196.44,283.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.91,274.75a15.06,15.06,0,0,1,6.74,11.84c0,4.35-3.09,6.09-6.84,3.9a15.08,15.08,0,0,1-6.74-11.85C178.1,274.29,181.16,272.55,184.91,274.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.56,281.27c0-1.7,1.05-2.47,2.32-1.73a5.51,5.51,0,0,1,2.28,4.42c0,1.7-1,2.48-2.32,1.73A5.51,5.51,0,0,1,182.56,281.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.92,268.75s.44,8-3.23,11.09c-.7.57-1.44,1-1.87,1.39-.94.87-.2,2.33,1,2.9,1.78.83,10.91-1.52,14.47-9.4Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,281.75a1.48,1.48,0,0,1,.74,1.14c0,.43-.26.62-.65.42a1.46,1.46,0,0,1-.74-1.13C184.34,281.75,184.64,281.56,185,281.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.62,269.78c-4.16,5.38-10.93,6.93-12.45,6.22-1.23-.57-1.95-2-1-2.9.43-.4,1.17-.81,1.87-1.4,2-1.69,2.71-4.63,2.9-6.93l8.07,4.65.52.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.23,278.05a15.07,15.07,0,0,0-6.74-11.84c-2-1.16-3.74-1.21-5-.39h0l-4.61,2.6,9.66,16.67,4.58-2.6h0C296.4,281.8,297.21,280.27,297.23,278.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.7,268.93a15,15,0,0,1,6.74,11.84c0,4.35-3.09,6.09-6.84,3.89a15,15,0,0,1-6.74-11.84C278.89,268.47,282,266.73,285.7,268.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.35,275.45c0-1.7,1-2.47,2.32-1.73a5.51,5.51,0,0,1,2.28,4.42c0,1.7-1.05,2.47-2.32,1.73A5.51,5.51,0,0,1,283.35,275.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.71,262.93s.44,8-3.23,11.08c-.7.58-1.44,1-1.87,1.4-.94.87-.2,2.33,1,2.9,1.78.83,10.91-1.52,14.47-9.4Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.81,275.93a1.46,1.46,0,0,1,.74,1.13c0,.43-.26.63-.65.43a1.46,1.46,0,0,1-.74-1.13C285.13,275.93,285.43,275.74,285.81,275.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.24,240.56l.11.06c-4.15,5.39-10.93,6.93-12.45,6.22-1.22-.57-2-2-1-2.9.43-.4,1.17-.81,1.87-1.39,2-1.7,2.71-4.64,2.9-6.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,248.89a15,15,0,0,0-6.74-11.84c-2-1.16-3.73-1.21-5-.39h0l-4.62,2.6,9.67,16.66,4.57-2.59h0C246.14,252.64,247,251.11,247,248.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.44,239.76a15.05,15.05,0,0,1,6.73,11.85c0,4.35-3.08,6.09-6.83,3.89a15.06,15.06,0,0,1-6.74-11.85C228.62,239.31,231.69,237.57,235.44,239.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.09,246.29c0-1.7,1-2.48,2.32-1.73a5.53,5.53,0,0,1,2.27,4.42c0,1.7-1,2.47-2.31,1.73A5.54,5.54,0,0,1,233.09,246.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.44,233.77s.45,8-3.23,11.08c-.69.58-1.44,1-1.87,1.4-.93.87-.2,2.33,1,2.9,1.78.83,10.91-1.52,14.47-9.4Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.55,246.77a1.49,1.49,0,0,1,.74,1.13c0,.43-.27.63-.65.43a1.5,1.5,0,0,1-.75-1.13C234.87,246.77,235.16,246.57,235.55,246.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.44,127.35l-1.9,1.11-1.47-6a18.7,18.7,0,0,0-7.58-10.06l-1.74-1a3.79,3.79,0,0,0-3.32,0l-11.82,6.8a1.05,1.05,0,1,1-1.05-1.82l11.82-6.81a6,6,0,0,1,5.42,0l1.74,1A20.84,20.84,0,0,1,227.11,122Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.18,136l-3.42-5.92,28.56-16.48h0a1.63,1.63,0,0,1,1.85.08,5.34,5.34,0,0,1,2.42,4.19,1.63,1.63,0,0,1-.85,1.65h0Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.18,136l-3.42-5.92,28.56-16.48h0a1.63,1.63,0,0,1,1.85.08,5.34,5.34,0,0,1,2.42,4.19,1.63,1.63,0,0,1-.85,1.65h0Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.76,130.12c.9-.52,2.4.38,3.34,2s1,3.38.08,3.9-2.39-.39-3.34-2S170.86,130.64,171.76,130.12Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.93,159.22l-1.9,1.09-1.47-6A18.74,18.74,0,0,0,163,144.29l-1.75-1a2.36,2.36,0,0,1,0-4.34l11.29-6.52c.28-.16.74.12,1,.62s.3,1.05,0,1.21h0l-11.29,6.52a.86.86,0,0,0-.38.34s.08.18.38.36l1.75,1a20.84,20.84,0,0,1,8.56,11.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.69 196.77 177.69 229.68 261 277.77 317.99 244.86 234.69 196.77",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.69 196.77 177.69 229.68 261 277.77 317.99 244.86 234.69 196.77",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.03 160.31 228.44 127.35 234.69 196.77 177.69 229.68 172.03 160.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.44,127.35l6.25,69.42L318,244.86l13.16-58.22Zm29.13,66.74a4.77,4.77,0,0,1-6-3.09l-13.77-35.73a4.49,4.49,0,1,1,8.32-3.21l13.77,35.73A4.78,4.78,0,0,1,257.57,194.09Zm26,12.24a4.78,4.78,0,0,1-6-3.09l-13.77-35.73c-1-2.6.05-5.42,2.35-6.3a4.77,4.77,0,0,1,6,3.09L285.93,200A4.77,4.77,0,0,1,283.58,206.33Zm26,12.24a4.77,4.77,0,0,1-6-3.1l-13.77-35.72a4.49,4.49,0,1,1,8.32-3.21l13.77,35.73A4.77,4.77,0,0,1,309.59,218.57Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.29,93.76c-4.27-2.46-7.76-2.61-10.49-1l-11.36,6.56c-5.07,2.91-7.54,11.75-7.54,22.83,0,17.08,5.68,34.79,18,41.92,4.47,2.58,8,2.79,10.8,1.21l11.4-6.58c4.9-2.84,7.19-11.36,7.19-22.28C255.32,119.3,249.64,100.89,237.29,93.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21,109.57c-3-6.84-7.23-12.52-12.92-15.81-4.27-2.46-7.76-2.61-10.49-1l-11.36,6.56a10.78,10.78,0,0,0-3.8,4l24.7,14.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.93,164c-12.35-7.13-18-24.84-18-41.92s5.86-28.82,18-21.79c12.35,7.13,18,25.54,18,42.61S238.37,171.21,225.93,164Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.93,117c-3.78-2.19-6,.54-6,12.06,0,10.82,2.35,16.06,6,18.2s6-.13,6-11.23S229.9,119.27,225.93,117Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.24 115.55 270.61 108.83 259.25 115.39 232.56 215.19 244.28 221.96 255.64 215.4 282.24 115.55",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.88 122.11 244.28 221.96 232.56 215.19 259.25 115.39 270.88 122.11",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.24 115.55 270.88 122.11 244.28 221.96 255.64 215.4 282.24 115.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.26,166.57c-4.27-2.47-7.76-2.62-10.49-1l-11.36,6.57c-5.07,2.91-7.54,11.74-7.54,22.83,0,17.07,5.68,34.79,18,41.92,4.47,2.57,8.05,2.78,10.8,1.2l11.39-6.58c4.91-2.84,7.2-11.36,7.2-22.28C308.29,192.11,302.61,173.7,290.26,166.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.18,182.38c-3-6.84-7.23-12.53-12.92-15.81-4.27-2.47-7.76-2.62-10.49-1l-11.36,6.57a10.83,10.83,0,0,0-3.8,4l24.7,14.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.9,236.84c-12.35-7.13-18-24.85-18-41.92s5.86-28.82,18-21.8c12.35,7.14,18,25.55,18,42.62S291.34,244,278.9,236.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.9,189.78c-3.78-2.18-6,.54-6,12.06,0,10.83,2.35,16.07,6,18.2s6-.12,6-11.22C284.94,197.57,282.87,192.07,278.9,189.78Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M172,160.31l5.66,69.37L261,277.78l13.15-58.23Zm32.88,68.28a4.76,4.76,0,0,1-6-3.09l-13.76-35.73a4.49,4.49,0,1,1,8.32-3.2l13.76,35.73A4.76,4.76,0,0,1,204.91,228.59Zm26,12.24c-2.29.89-5-.5-6-3.09L211.19,202a4.49,4.49,0,1,1,8.32-3.2l13.76,35.72C234.27,237.13,233.22,240,230.92,240.83Zm26,12.24c-2.29.89-5-.5-6-3.09L237.2,214.25a4.49,4.49,0,1,1,8.32-3.21l13.77,35.73A4.77,4.77,0,0,1,256.93,253.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.15 219.55 331.15 186.65 317.99 244.87 261 277.77 274.15 219.55",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Megaphone--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--megaphone--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.4,199.25a16.17,16.17,0,1,0,16.15-16.18A16.17,16.17,0,0,0,357.4,199.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.49,201.29l18.25,10.51a16.16,16.16,0,0,1-23.58-21.59C358.72,194.34,359.62,197.91,365.49,201.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.76,210.39,388,203.87c-3.44,13-5.36,32.51-4.45,46.82l-4.5,2.6C376.41,244.69,375.8,227.13,376.76,210.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.07,210.3l4.75,6L368,234a22.54,22.54,0,0,0,11.1,19.26h0c-2.71-10.24-3-27.66-2.3-42.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.07,230.44l-.33.19a2.1,2.1,0,0,1-1.92,0l-2.58-1.48c-.53-.31-1-.06-1,.55v.38a2.11,2.11,0,0,0,1,1.66l2.62,1.52a2.08,2.08,0,0,0,1.91,0l.31-.18a2.17,2.17,0,0,0,.95-1.68V231C379,230.38,378.6,230.13,378.07,230.44Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.48,236.24l-.33.19a2.16,2.16,0,0,1-1.92,0l-2.58-1.49c-.53-.3-1-.05-1,.56v.38a2.13,2.13,0,0,0,1,1.66l2.62,1.51a2.08,2.08,0,0,0,1.91,0l.31-.19a2.15,2.15,0,0,0,.95-1.68v-.38C379.44,236.18,379,235.93,378.48,236.24Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.89,242l-.33.19a2.1,2.1,0,0,1-1.92,0l-2.58-1.48c-.53-.31-1-.06-1,.55v.38a2.15,2.15,0,0,0,1,1.67l2.62,1.51a2.08,2.08,0,0,0,1.91,0l.31-.18a2.17,2.17,0,0,0,1-1.68v-.39C379.85,242,379.42,241.72,378.89,242Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.62,189.49h0c-2.17-1.24-5.08-1.18-8.31.4-.34.16-.68.35-1,.55a14.29,14.29,0,0,0-1.21.76,20.61,20.61,0,0,0-1.92,1.49A26.31,26.31,0,0,0,378.9,196,31.88,31.88,0,0,0,373,207.37a21.86,21.86,0,0,0-.87,6c0,4.11,1.41,7,3.7,8.45l-8.14-4.69h0a10.52,10.52,0,0,1-4.81-9.08,22.14,22.14,0,0,1,.8-5.71,31.43,31.43,0,0,1,6-11.62,26.23,26.23,0,0,1,3.24-3.33,20.61,20.61,0,0,1,1.92-1.49c.4-.27.81-.53,1.21-.76s.7-.38,1-.54a10.43,10.43,0,0,1,9.23.14h0l.23.12.29.18Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.65,217.12h0a10.52,10.52,0,0,1-4.81-9.08,22.14,22.14,0,0,1,.8-5.71l9.31,5.05a21.86,21.86,0,0,0-.87,6c0,4.11,1.41,7,3.7,8.45Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.52,198.06c0,8.43-5.9,18.69-13.2,22.91-3.67,2.13-7,2.32-9.39.91l-.14-.07c-2.29-1.42-3.7-4.34-3.7-8.45,0-8.44,5.89-18.7,13.19-22.92,3.64-2.11,7-2.32,9.34-.95S398.51,193.83,398.52,198.06Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.52,198.06c0,8.43-5.9,18.69-13.2,22.91-3.67,2.13-7,2.32-9.39.91l-.14-.07c-2.29-1.42-3.7-4.34-3.7-8.45,0-8.44,5.89-18.7,13.19-22.92,3.64-2.11,7-2.32,9.34-.95S398.51,193.83,398.52,198.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.06,195.83s-13.34,6.86-24.71,26.61a89.9,89.9,0,0,0-5.39,11c-5.71,14-5.22,23.71-5.22,23.71-4-9.73-8.94-19.81-17.2-27.52a124.1,124.1,0,0,0-10.15-8.47h0c-2.18-1.26-3.46-4-3.47-7.81a23.12,23.12,0,0,1,1.49-7.77,30.69,30.69,0,0,1,2.25-4.84,26.19,26.19,0,0,1,9-9.57c3.28-1.9,6.3-2.17,8.49-.92h0a124.6,124.6,0,0,0,12.42,4.53C417.43,198,428.64,197.27,439.06,195.83Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.06,195.83s-13.34,6.86-24.71,26.61a89.9,89.9,0,0,0-5.39,11c-5.71,14-5.22,23.71-5.22,23.71-4-9.73-8.94-19.81-17.2-27.52a124.1,124.1,0,0,0-10.15-8.47h0c-2.18-1.26-3.46-4-3.47-7.81a23.12,23.12,0,0,1,1.49-7.77,30.69,30.69,0,0,1,2.25-4.84,26.19,26.19,0,0,1,9-9.57c3.28-1.9,6.3-2.17,8.49-.92h0a124.6,124.6,0,0,0,12.42,4.53C417.43,198,428.64,197.27,439.06,195.83Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,233.45c-5.71,14-5.22,23.71-5.22,23.71-4-9.73-8.94-19.81-17.2-27.52a124.1,124.1,0,0,0-10.15-8.47h0c-2.18-1.26-3.46-4-3.47-7.81a23.12,23.12,0,0,1,1.49-7.77C384.53,210.63,400.9,220,409,233.45Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.21,214.84c0,8.79-2.69,18.42-7.19,27.32h0c-5.76,11.39-14.47,21.57-24.22,27.21-17.37,10.05-31.46,1.93-31.49-18.13A53.53,53.53,0,0,1,403.38,237a74.93,74.93,0,0,1,19-32.33q1.84-1.81,3.79-3.42c.53-.44,1.08-.87,1.63-1.29h0c.78-.59,1.56-1.16,2.36-1.69s1.67-1.09,2.52-1.58C450.09,186.65,464.19,194.77,464.21,214.84Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457,242.16c-5.76,11.39-14.47,21.57-24.22,27.21-17.37,10.05-31.46,1.93-31.49-18.13A53.53,53.53,0,0,1,403.38,237h0c1.18,2.6,5.41,6.3,7.3,3.7a47.84,47.84,0,0,0-1.81,12.62c0,5.76,1.3,10.42,3.73,13.46a10.31,10.31,0,0,0,8.47,3.9c3.44,0,7.45-1.27,11.58-3.66,8.29-4.8,15.91-13.42,21.31-23.18C454,243.85,455.05,244.76,457,242.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.06,216c0,8.86-3.09,18.87-8.1,27.89-5.4,9.76-13,18.38-21.31,23.18-4.13,2.39-8.14,3.66-11.58,3.66a10.31,10.31,0,0,1-8.47-3.9c-2.43-3-3.72-7.7-3.73-13.46a47.84,47.84,0,0,1,1.81-12.62c.44-1.63,1-3.27,1.55-4.9a71.91,71.91,0,0,1,3.7-8.43c.3-.56.59-1.12.9-1.68.5-.92,1-1.85,1.58-2.74a70.43,70.43,0,0,1,6.19-8.74l.08-.09a63.06,63.06,0,0,1,4.69-5q1.75-1.68,3.59-3.15c.51-.41,1-.8,1.54-1.19s1.26-.89,1.9-1.31,1.24-.79,1.87-1.16c4.14-2.4,8.14-3.66,11.59-3.67C457.49,198.6,462.05,205.09,462.06,216Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.06,216c0,8.86-3.09,18.87-8.1,27.89-5.4,9.76-13,18.38-21.31,23.18-4.13,2.39-8.14,3.66-11.58,3.66a10.31,10.31,0,0,1-8.47-3.9c-2.43-3-3.72-7.7-3.73-13.46a47.84,47.84,0,0,1,1.81-12.62c.44-1.63,1-3.27,1.55-4.9a71.91,71.91,0,0,1,3.7-8.43c.3-.56.59-1.12.9-1.68.5-.92,1-1.85,1.58-2.74a70.43,70.43,0,0,1,6.19-8.74l.08-.09a63.06,63.06,0,0,1,4.69-5q1.75-1.68,3.59-3.15c.51-.41,1-.8,1.54-1.19s1.26-.89,1.9-1.31,1.24-.79,1.87-1.16c4.14-2.4,8.14-3.66,11.59-3.67C457.49,198.6,462.05,205.09,462.06,216Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.31,223.62l-10.71,19c-4.51-2.38-10-5.35-16.93-5.18.18-.54.37-1.08.56-1.63a69.52,69.52,0,0,1,3.71-8.42c.29-.57.59-1.13.89-1.68.5-.93,1-1.85,1.58-2.75a72.27,72.27,0,0,1,6.19-8.74.34.34,0,0,0,.08-.09c.33-.4.67-.79,1-1.17C429.14,219.1,439.31,223.62,439.31,223.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.09,242.92c-2.34,0-3.74-1.89-3.75-5v-.1a17.31,17.31,0,0,1,7.81-13.55l.08-.05a6.68,6.68,0,0,1,3.27-1c2.34,0,3.74,1.89,3.74,5.06v.09a17.31,17.31,0,0,1-7.8,13.56l-.09,0a6.62,6.62,0,0,1-3.26,1Z",
    style: {
      fill: "#FB923C"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--button-2--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Button--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.61,422.25l57,33a4.66,4.66,0,0,0,4.21,0l56.21-32.36a4.58,4.58,0,0,0,2.08-3.65l0-4.61a4.73,4.73,0,0,0-2.13-3.65l-57-33a4.66,4.66,0,0,0-4.21,0l-56.21,32.36a4.59,4.59,0,0,0-2.08,3.65l0,4.61A4.73,4.73,0,0,0,151.61,422.25Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,410.94a4.84,4.84,0,0,1,2.13,3.65l0,4.61a4.6,4.6,0,0,1-2.08,3.65l-56.21,32.36a4.24,4.24,0,0,1-2.19.49v-9.47a4.17,4.17,0,0,0,2.11-.5L269,413.37C270,412.76,270.22,411.65,269,410.94Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.53,412.77l57,33a4.66,4.66,0,0,0,4.21,0L248.91,425,269,413.37a1.28,1.28,0,0,0,0-2.43l-57-33a4.66,4.66,0,0,0-4.21,0l-56.21,32.36A1.28,1.28,0,0,0,151.53,412.77Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.53,412.77l57,33a4.66,4.66,0,0,0,4.21,0L248.91,425,269,413.37a1.28,1.28,0,0,0,0-2.43l-57-33a4.66,4.66,0,0,0-4.21,0l-56.21,32.36A1.28,1.28,0,0,0,151.53,412.77Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M184.14,414.11a.86.86,0,0,1-.74-.42.85.85,0,0,1,.31-1.16l7.39-4.32a.85.85,0,0,1,.86,1.47L184.57,414A.86.86,0,0,1,184.14,414.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.91,422.61a1,1,0,0,1-.29-.05L178.15,412l-6.16.71a.85.85,0,1,1-.19-1.69l6.35-.74a.86.86,0,0,1,.39.05l29.29,10.46,20.31-11.72-13.39-12.73-6.77,4a.85.85,0,0,1-1.17-.31.84.84,0,0,1,.31-1.16l7.32-4.28a.86.86,0,0,1,1,.12l14.68,13.95a.86.86,0,0,1,.26.71.85.85,0,0,1-.42.64l-21.64,12.49A.82.82,0,0,1,207.91,422.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.93,426.28a7.24,7.24,0,0,1-3.54-.89,3.09,3.09,0,0,1-1.78-2.54,2.45,2.45,0,0,1,1.38-2.12l9.44-5.45a.84.84,0,0,1,1.16.31.86.86,0,0,1-.31,1.16l-9.44,5.45c-.2.12-.53.35-.53.65s.25.67.93,1.06a5.26,5.26,0,0,0,4.67.23l20.9-12.07a.86.86,0,0,1,1.17.32.86.86,0,0,1-.32,1.16l-20.9,12.07A5.8,5.8,0,0,1,211.93,426.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.24,430.05a7.37,7.37,0,0,1-3.58-.9,3.11,3.11,0,0,1-1.79-2.56,2.48,2.48,0,0,1,1.39-2.14,7,7,0,0,1,6.43.23,3.11,3.11,0,0,1,1.79,2.56,2.48,2.48,0,0,1-1.39,2.14A5.8,5.8,0,0,1,223.24,430.05Zm-1.14-4.57a4.09,4.09,0,0,0-2,.44c-.2.12-.54.36-.54.67s.25.68.94,1.08a5.36,5.36,0,0,0,4.73.23c.2-.11.54-.35.54-.66s-.25-.68-.94-1.08h0A5.65,5.65,0,0,0,222.1,425.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.05,421.49a7.32,7.32,0,0,1-3.58-.9,3.1,3.1,0,0,1-1.79-2.56,2.47,2.47,0,0,1,1.39-2.13,7,7,0,0,1,6.43.23h0a3.12,3.12,0,0,1,1.8,2.56,2.46,2.46,0,0,1-1.4,2.13A5.75,5.75,0,0,1,238.05,421.49Zm-1.13-4.56a4.11,4.11,0,0,0-2,.44c-.2.12-.53.36-.53.66s.24.69.93,1.09a5.39,5.39,0,0,0,4.73.23c.2-.12.54-.36.54-.66s-.24-.69-.94-1.09A5.72,5.72,0,0,0,236.92,416.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.3,412.21a21,21,0,0,1-10.24-2.55c-3-1.72-4.68-4.05-4.68-6.41,0-2,1.22-3.81,3.43-5.09,4.67-2.7,12.84-2.37,18.21.72,3,1.72,4.67,4.05,4.67,6.41,0,2-1.21,3.81-3.43,5.09A16.2,16.2,0,0,1,201.3,412.21ZM197.77,398a14.45,14.45,0,0,0-7.11,1.63c-1.66,1-2.58,2.24-2.58,3.61,0,1.73,1.4,3.53,3.83,4.93,4.89,2.83,12.29,3.15,16.5.72,1.66-1,2.58-2.24,2.58-3.61,0-1.73-1.39-3.53-3.82-4.93h0A19.36,19.36,0,0,0,197.77,398Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.28,407.9h0l-6.84-.27a.86.86,0,0,1-.82-.89.82.82,0,0,1,.89-.81l5.56.21L198.76,400a.85.85,0,1,1,1.6-.59l2.71,7.34a.86.86,0,0,1-.79,1.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.71,424.86a.87.87,0,0,1-.74-.43.85.85,0,0,1,.32-1.16l4.74-2.74a.85.85,0,0,1,1.16.31.87.87,0,0,1-.31,1.17l-4.74,2.73A.85.85,0,0,1,227.71,424.86Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--button-1--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--button--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269,352.38l28.11,16.26a4.66,4.66,0,0,0,4.21,0L387.55,319a4.56,4.56,0,0,0,2.08-3.65l0-4.61a4.75,4.75,0,0,0-2.13-3.65l-28.11-16.26a4.66,4.66,0,0,0-4.21,0l-86.24,49.6a4.6,4.6,0,0,0-2.08,3.65l0,4.61A4.7,4.7,0,0,0,269,352.38Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.47,307.13a4.82,4.82,0,0,1,2.13,3.65l0,4.61a4.56,4.56,0,0,1-2.08,3.65l-86.23,49.6a4.28,4.28,0,0,1-2.2.49v-9.47a4.17,4.17,0,0,0,2.11-.5l86.22-49.59C388.53,309,388.71,307.85,387.47,307.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.91,342.9,297,359.16a4.68,4.68,0,0,0,4.22,0l36.14-20.77,50.09-28.83a1.28,1.28,0,0,0,0-2.43l-28.11-16.26a4.66,4.66,0,0,0-4.21,0l-86.24,49.6A1.28,1.28,0,0,0,268.91,342.9Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.91,342.9,297,359.16a4.68,4.68,0,0,0,4.22,0l36.14-20.77,50.09-28.83a1.28,1.28,0,0,0,0-2.43l-28.11-16.26a4.66,4.66,0,0,0-4.21,0l-86.24,49.6A1.28,1.28,0,0,0,268.91,342.9Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M296.22,350.86a1.9,1.9,0,0,1-.86-.27l-13.48-7.78c-.29-.17-.43-.33-.44-.49s.13-.31.4-.47l3.88-2.24q4.56-2.62,8.23-.51c1.62.93,2.16,2,1.62,3.19l.11,0a7.19,7.19,0,0,1,3-.27,7.5,7.5,0,0,1,2.95,1c1.29.75,1.91,1.58,1.86,2.51s-.89,1.87-2.51,2.8l-4,2.28A1.63,1.63,0,0,1,296.22,350.86Zm-4.29-7.69c.46-.27.66-.55.59-.85s-.43-.64-1.07-1a3.89,3.89,0,0,0-1.65-.59,2.39,2.39,0,0,0-1.41.35l-1.54.89,3.58,2.06Zm6.53,3.6c.54-.31.78-.63.73-.95s-.42-.68-1.12-1.08a3.89,3.89,0,0,0-1.79-.61,3.05,3.05,0,0,0-1.62.44l-1.64,1,3.79,2.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.14,343a8.74,8.74,0,0,1-4.8-1.17L293.25,336c-.46-.27-.27-.65.57-1.13l.87-.5c.83-.49,1.49-.59,1.95-.33l9.87,5.7a4.11,4.11,0,0,0,1.94.55,3.46,3.46,0,0,0,1.9-.46c.55-.32.81-.68.77-1.1s-.34-.78-.92-1.12l-9.87-5.7c-.47-.26-.28-.64.56-1.12l.85-.49q1.26-.74,1.95-.33l10.09,5.83c1.46.84,2.14,1.76,2,2.76s-1,2-2.62,2.91A10.88,10.88,0,0,1,308.14,343Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.24,335.31l-5.9-3.4-11-2.52a3.22,3.22,0,0,1-.74-.2c-.13-.08-.12-.2,0-.38a3.5,3.5,0,0,1,.85-.62l1.1-.64a2.27,2.27,0,0,1,1.61-.45l7,2.1-3.67-4.05c-.11-.11-.1-.25.05-.4a3.48,3.48,0,0,1,.73-.52l.91-.53c.92-.52,1.52-.7,1.81-.54a2.44,2.44,0,0,1,.39.4l4.42,6.42,5.84,3.37c.22.14.28.3.2.49a2,2,0,0,1-.79.65l-.84.49C323.36,335.47,322.71,335.58,322.24,335.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.29,328.94l-13.89-8c-.46-.27-.27-.64.56-1.13l.57-.32a2.66,2.66,0,0,1,.81-.33,2.12,2.12,0,0,1,.93,0l11,1.83c.58.1,1.39.28,2.44.55l0-.08a18.12,18.12,0,0,1-1.89-.89l-6.92-4c-.46-.27-.28-.65.56-1.13l.52-.3c.84-.49,1.49-.6,2-.33l13.88,8c.47.27.28.64-.56,1.13l-.41.24a3.22,3.22,0,0,1-.84.34,2.15,2.15,0,0,1-.94,0l-11.52-1.87a20.21,20.21,0,0,1-2-.46l0,.1a16.74,16.74,0,0,1,1.65.75l7.14,4.12c.46.27.27.65-.57,1.13l-.52.3Q334,329.35,333.29,328.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.84,317.71q-7.77-4.48-2.08-7.76a10.35,10.35,0,0,1,6.11-1.35,17.56,17.56,0,0,1,7.32,2.56q4,2.31,4.44,4.23t-2.33,3.53Q346.62,322.19,338.84,317.71Zm11.46-1.42c0-.36-.23-.78-.79-1.29a17.51,17.51,0,0,0-2.75-1.86,20.45,20.45,0,0,0-3.2-1.57,6.1,6.1,0,0,0-2.22-.46,3.56,3.56,0,0,0-1.69.48c-.52.3-.8.63-.84,1s.22.79.77,1.3a16.46,16.46,0,0,0,2.71,1.85,20.57,20.57,0,0,0,3.23,1.57,5.87,5.87,0,0,0,2.25.45,3.6,3.6,0,0,0,1.71-.48C350,317,350.27,316.64,350.3,316.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.45,313.35a1.07,1.07,0,0,1-.62,0l-16.78-6.41a.44.44,0,0,1-.19-.1l-.13-.08c-.38-.22-.14-.58.71-1.07l.63-.36a2.38,2.38,0,0,1,2.06-.42l9,4,1.76.79,1.89.86-2.24-1.74-.52-.43-6.9-5.51a.24.24,0,0,1-.09-.36,2.24,2.24,0,0,1,.65-.49l1.09-.63a3.29,3.29,0,0,1,.85-.37,1,1,0,0,1,.62,0l9.53,4,3.8,1.65-2-1.52-.87-.65-7-5.23c-.39-.29-.16-.69.71-1.19l.5-.28c.85-.5,1.47-.63,1.85-.42a2.57,2.57,0,0,1,.3.2l11,9.71c.25.21.06.5-.56.85l-1.43.83a1.71,1.71,0,0,1-1.43.3l-9.14-3.57-2.56-1.2,2.06,1.49,6.16,5.29c.25.21.08.48-.52.82l-1.43.83A3,3,0,0,1,361.45,313.35Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--stars--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.07,365.66a7.27,7.27,0,0,1-3.39,5.63L373.45,429.73a7.48,7.48,0,0,1-6.77,0l-25-14.43a6.36,6.36,0,0,1,0-11.24l101.23-58.45a7.5,7.5,0,0,1,6.78,0l25,14.43A7.27,7.27,0,0,1,478.07,365.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.19,360.38c1.34,1.09,1.17,2.6-.51,3.57l-42.2,24.36-59,34.08a7,7,0,0,1-3.39.82v7.33a7,7,0,0,0,3.38-.8l101.23-58.46a6.32,6.32,0,0,0,.51-10.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.68,422.4l-25-14.43c-1.87-1.08-1.87-2.83,0-3.91l101.23-58.45a7.5,7.5,0,0,1,6.78,0l25,14.43c1.87,1.08,1.87,2.83,0,3.91l-42.2,24.36-59,34.09A7.48,7.48,0,0,1,366.68,422.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--stars--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.11,358.5l2.22,3.19a.4.4,0,0,1-.09.57l-3.08,2.49c-.49.4.11,1,1,1.05l5.68.19a1.65,1.65,0,0,1,.94.31l3.62,2.81c.58.45,1.71.4,1.91-.09l1.3-3.07a.8.8,0,0,1,.67-.38l5.31-.76c.85-.11.95-.77.17-1.1l-4.88-2.09c-.31-.13-.51-.33-.53-.54L451,357.8c-.06-.52-1.13-.87-1.81-.59L444.91,359a1.72,1.72,0,0,1-1,.05l-5.52-1.28C437.52,357.56,436.76,358,437.11,358.5Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.47,369.35l2.22,3.19a.39.39,0,0,1-.09.57l-3.08,2.5c-.48.39.11,1,1,1l5.68.19a1.65,1.65,0,0,1,.94.31l3.62,2.82c.58.44,1.71.39,1.91-.1l1.3-3.07a.81.81,0,0,1,.67-.38l5.31-.75c.85-.12.95-.77.17-1.11l-4.88-2.09c-.31-.13-.51-.33-.53-.54l-.33-3.28c-.06-.52-1.13-.87-1.81-.59l-4.32,1.78a1.72,1.72,0,0,1-1,.05l-5.52-1.28C418.88,368.41,418.12,368.85,418.47,369.35Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.83,380.2l2.22,3.19a.39.39,0,0,1-.09.57l-3.07,2.5c-.49.39.11,1,1,1l5.69.19a1.72,1.72,0,0,1,.93.31l3.62,2.82c.58.45,1.71.39,1.91-.1l1.3-3.07a.81.81,0,0,1,.67-.38l5.32-.75c.84-.12.94-.77.16-1.11l-4.88-2.09c-.31-.13-.51-.33-.53-.54l-.33-3.28c-.06-.52-1.12-.87-1.81-.59l-4.32,1.78a1.72,1.72,0,0,1-1,.05l-5.52-1.28C400.24,379.26,399.48,379.7,399.83,380.2Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.19,391.05l2.22,3.19a.4.4,0,0,1-.09.58l-3.07,2.49c-.49.39.11,1,1,1l5.69.2a1.59,1.59,0,0,1,.93.3l3.62,2.82c.58.45,1.71.39,1.92-.1l1.29-3.07a.85.85,0,0,1,.67-.38l5.32-.75c.84-.12.94-.77.16-1.1L396,394.18c-.31-.14-.51-.34-.53-.55l-.33-3.28c-.06-.52-1.12-.87-1.81-.58L389,391.54a1.72,1.72,0,0,1-1,0l-5.52-1.28C381.6,390.11,380.84,390.55,381.19,391.05Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.56,401.91l2.21,3.18a.4.4,0,0,1-.09.58l-3.07,2.49c-.49.4.11,1,1,1l5.69.2a1.59,1.59,0,0,1,.93.3l3.63,2.82c.57.45,1.7.39,1.91-.1l1.3-3.07a.82.82,0,0,1,.66-.38l5.32-.75c.84-.12.94-.77.16-1.1L377.34,405a.81.81,0,0,1-.53-.55l-.33-3.28c-.06-.52-1.12-.87-1.81-.58l-4.32,1.77a1.64,1.64,0,0,1-1,.05l-5.52-1.28C363,401,362.2,401.4,362.56,401.91Z",
    style: {
      fill: "#FB923C"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--stars--inject-5",
    style: {
      opacity: 0.65
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.11,358.5l2.22,3.19a.4.4,0,0,1-.09.57l-3.08,2.49c-.49.4.11,1,1,1.05l5.68.19a1.65,1.65,0,0,1,.94.31l3.62,2.81c.58.45,1.71.4,1.91-.09l1.3-3.07a.8.8,0,0,1,.67-.38l5.31-.76c.85-.11.95-.77.17-1.1l-4.88-2.09c-.31-.13-.51-.33-.53-.54L451,357.8c-.06-.52-1.13-.87-1.81-.59L444.91,359a1.72,1.72,0,0,1-1,.05l-5.52-1.28C437.52,357.56,436.76,358,437.11,358.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.47,369.35l2.22,3.19a.39.39,0,0,1-.09.57l-3.08,2.5c-.48.39.11,1,1,1l5.68.19a1.65,1.65,0,0,1,.94.31l3.62,2.82c.58.44,1.71.39,1.91-.1l1.3-3.07a.81.81,0,0,1,.67-.38l5.31-.75c.85-.12.95-.77.17-1.11l-4.88-2.09c-.31-.13-.51-.33-.53-.54l-.33-3.28c-.06-.52-1.13-.87-1.81-.59l-4.32,1.78a1.72,1.72,0,0,1-1,.05l-5.52-1.28C418.88,368.41,418.12,368.85,418.47,369.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.83,380.2l2.22,3.19a.39.39,0,0,1-.09.57l-3.07,2.5c-.49.39.11,1,1,1l5.69.19a1.72,1.72,0,0,1,.93.31l3.62,2.82c.58.45,1.71.39,1.91-.1l1.3-3.07a.81.81,0,0,1,.67-.38l5.32-.75c.84-.12.94-.77.16-1.11l-4.88-2.09c-.31-.13-.51-.33-.53-.54l-.33-3.28c-.06-.52-1.12-.87-1.81-.59l-4.32,1.78a1.72,1.72,0,0,1-1,.05l-5.52-1.28C400.24,379.26,399.48,379.7,399.83,380.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.19,391.05l2.22,3.19a.4.4,0,0,1-.09.58l-3.07,2.49c-.49.39.11,1,1,1l5.69.2a1.59,1.59,0,0,1,.93.3l3.62,2.82c.58.45,1.71.39,1.92-.1l1.29-3.07a.85.85,0,0,1,.67-.38l5.32-.75c.84-.12.94-.77.16-1.1L396,394.18c-.31-.14-.51-.34-.53-.55l-.33-3.28c-.06-.52-1.12-.87-1.81-.58L389,391.54a1.72,1.72,0,0,1-1,0l-5.52-1.28C381.6,390.11,380.84,390.55,381.19,391.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.56,401.91l2.21,3.18a.4.4,0,0,1-.09.58l-3.07,2.49c-.49.4.11,1,1,1l5.69.2a1.59,1.59,0,0,1,.93.3l3.63,2.82c.57.45,1.7.39,1.91-.1l1.3-3.07a.82.82,0,0,1,.66-.38l5.32-.75c.84-.12.94-.77.16-1.1L377.34,405a.81.81,0,0,1-.53-.55l-.33-3.28c-.06-.52-1.12-.87-1.81-.58l-4.32,1.77a1.64,1.64,0,0,1-1,.05l-5.52-1.28C363,401,362.2,401.4,362.56,401.91Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.9,138.86l5.07-9.53-4.08-11.76v-7.2l12.48,7.2v7.2L337,134.06a.74.74,0,0,1-.36.32h0Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.9,138.86l5.07-9.53-4.08-11.76v-7.2l12.48,7.2v7.2L337,134.06a.74.74,0,0,1-.36.32h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.12,68.85a8.27,8.27,0,0,1,3.74-6.48l3.05-1.76a8.26,8.26,0,0,1,7.47,0l79.8,46.08a8.27,8.27,0,0,1,3.74,6.47v35.66a8.27,8.27,0,0,1-3.74,6.47l-3.05,1.76a8.28,8.28,0,0,1-7.48,0l-48.12-27.74-5.35,9.27a.8.8,0,0,1-1.44-.14l-5.66-16.33L302.86,111a8.25,8.25,0,0,1-3.74-6.48Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.91,148.82a8.26,8.26,0,0,1-3.73,6.47l-3.05,1.76a8.35,8.35,0,0,1-6.84.3c1.76.67,3.1-.32,3.1-2.46V119.24a7.73,7.73,0,0,0-1.09-3.69l10.52-6.07a7.58,7.58,0,0,1,1.09,3.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.24,67.78c.44-1.58,1.89-2.09,3.61-1.09l79.8,46.07a7.44,7.44,0,0,1,2.64,2.8l10.52-6.07a7.6,7.6,0,0,0-2.64-2.8L313.39,60.62a8.28,8.28,0,0,0-7.48,0l-3.06,1.76A8.26,8.26,0,0,0,299.24,67.78Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M305.52,97.59a1.55,1.55,0,0,1-.14-.7V84.26c0-.29.05-.47.14-.54s.23-.06.43,0l4.51,2.6a.8.8,0,0,1,.33.44,2.4,2.4,0,0,1,.11.84v.63a1.45,1.45,0,0,1-.11.71c-.07.12-.18.14-.33.05l-2.69-1.55v3l2.38,1.38a.78.78,0,0,1,.34.44,2.67,2.67,0,0,1,.1.84v.63a1.62,1.62,0,0,1-.1.71c-.07.12-.19.14-.34,0l-2.38-1.38v3.3l2.7,1.57a.7.7,0,0,1,.33.43,2.64,2.64,0,0,1,.1.83v.63a1.65,1.65,0,0,1-.1.72c-.07.13-.17.14-.33.06L306,98A1,1,0,0,1,305.52,97.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.82,96.86a2.67,2.67,0,0,1-.11-.84v-.14a1.59,1.59,0,0,1,.11-.71c.07-.13.18-.14.33,0l2.62,1.5a.8.8,0,0,1,.33.44,2.71,2.71,0,0,1,.11.84V98a1.56,1.56,0,0,1-.11.71c-.07.13-.18.14-.33,0l-2.62-1.5A.8.8,0,0,1,311.82,96.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,102.78a16.07,16.07,0,0,1-1-6.13c0-2.45.34-4.07,1-4.88s1.73-.79,3.14,0a6.66,6.66,0,0,1,1.33,1,1.52,1.52,0,0,1,.48,1.15,3.21,3.21,0,0,1-.21,1.26q-.21.49-.51.18a5,5,0,0,0-1-.77c-.61-.35-1.07-.24-1.37.33a7.51,7.51,0,0,0-.45,3.14,12.32,12.32,0,0,0,.45,3.68,3.31,3.31,0,0,0,1.45,2,2.3,2.3,0,0,0,.49.23,4.62,4.62,0,0,0,.51.13.3.3,0,0,1,.14.06,1.15,1.15,0,0,1,.46.77,6,6,0,0,1,.15,1.44,1,1,0,0,1-.09.46.34.34,0,0,1-.35.14,3.05,3.05,0,0,1-.69-.19,5,5,0,0,1-.88-.42A7.13,7.13,0,0,1,317,102.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.64,100.54q0-7.31,4-5a7.17,7.17,0,0,1,3,3.49,15.77,15.77,0,0,1,1,6.11c0,2.5-.34,4.15-1,4.94s-1.67.81-3,0Q322.64,107.83,322.64,100.54Zm4.9,7c.23-.14.4-.52.51-1.13a16.21,16.21,0,0,0,.17-2.7,20.21,20.21,0,0,0-.17-2.88,5,5,0,0,0-.51-1.71,2.37,2.37,0,0,0-.88-.92.88.88,0,0,0-.9-.11,1.7,1.7,0,0,0-.52,1.12,16.1,16.1,0,0,0-.17,2.68,20.36,20.36,0,0,0,.17,2.89,5.23,5.23,0,0,0,.52,1.73,2.41,2.41,0,0,0,.9.92A.82.82,0,0,0,327.54,107.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,110.71a2,2,0,0,1-.24-.52l-1.13-3.47c-.06-.18-.12-.39-.18-.62l-.14-.52h-.06a11.19,11.19,0,0,1,.09,1.17v7.05c0,.23-.07.36-.21.38a1.32,1.32,0,0,1-.68-.24l-.52-.3a2.37,2.37,0,0,1-.68-.54,1.07,1.07,0,0,1-.2-.62v-13c0-.24.07-.36.2-.38a1.11,1.11,0,0,1,.68.24l.48.27a2.16,2.16,0,0,1,.58.47,1.88,1.88,0,0,1,.33.63l1.9,5.88a9.52,9.52,0,0,1,.29,1.15,3.42,3.42,0,0,1,.27-.82l1.9-3.7a.4.4,0,0,1,.34-.24,1.16,1.16,0,0,1,.58.2l.47.28a2.23,2.23,0,0,1,.68.54,1,1,0,0,1,.21.62v13c0,.23-.07.36-.21.38a1.29,1.29,0,0,1-.68-.24l-.52-.3a2.37,2.37,0,0,1-.68-.54,1,1,0,0,1-.21-.62v-7.05a5.88,5.88,0,0,1,.11-1.06l-.06-.06a4.69,4.69,0,0,1-.34.77l-1.13,2.16a.41.41,0,0,1-.24.23.54.54,0,0,1-.37-.1l-.26-.15A1.28,1.28,0,0,1,336,110.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.5,116.79a1.68,1.68,0,0,1-.25-.52l-1.13-3.47c-.06-.18-.12-.39-.18-.62l-.14-.52h-.06a11.19,11.19,0,0,1,.09,1.17v7.05c0,.23-.07.36-.21.38a1.32,1.32,0,0,1-.68-.24l-.52-.3a2.37,2.37,0,0,1-.68-.54,1.07,1.07,0,0,1-.2-.62v-13c0-.24.07-.36.2-.39a1.27,1.27,0,0,1,.68.24l.48.28a2.16,2.16,0,0,1,.58.47,1.88,1.88,0,0,1,.33.63l1.9,5.88a9.52,9.52,0,0,1,.29,1.15,3,3,0,0,1,.28-.82l1.89-3.7a.4.4,0,0,1,.34-.24,1.16,1.16,0,0,1,.58.2l.47.28a2.23,2.23,0,0,1,.68.54,1,1,0,0,1,.21.62v13c0,.23-.07.36-.21.38a1.29,1.29,0,0,1-.68-.24l-.52-.3a2.37,2.37,0,0,1-.68-.54,1,1,0,0,1-.2-.62v-7.05a5.82,5.82,0,0,1,.1-1.06l-.06-.06a4.69,4.69,0,0,1-.34.77l-1.13,2.16a.41.41,0,0,1-.24.23.55.55,0,0,1-.37-.1l-.26-.15A1.12,1.12,0,0,1,346.5,116.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.28,125.17a1.58,1.58,0,0,1-.14-.7V111.83a.74.74,0,0,1,.14-.54c.09-.08.24-.06.43,0l4.51,2.61a.76.76,0,0,1,.33.44,2.34,2.34,0,0,1,.11.83v.63a1.5,1.5,0,0,1-.11.72c-.07.12-.18.14-.33.05l-2.69-1.56v3l2.38,1.38a.72.72,0,0,1,.34.43,2.71,2.71,0,0,1,.11.84v.63a1.56,1.56,0,0,1-.11.71c-.07.13-.18.14-.34,0l-2.38-1.37V124l2.7,1.56a.69.69,0,0,1,.33.44,2.6,2.6,0,0,1,.1.83v.63a1.71,1.71,0,0,1-.1.72c-.06.12-.17.14-.33.05l-4.52-2.61A1.07,1.07,0,0,1,353.28,125.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.08,128.68V115.84q0-.44.15-.54c.09-.07.25,0,.46.08l2.56,1.47a6.35,6.35,0,0,1,2.26,2.23,6.85,6.85,0,0,1,.85,3.58c0,1.59-.48,2.46-1.45,2.61v.08a4.24,4.24,0,0,1,.61,1.17,8.91,8.91,0,0,1,.42,1.46l.9,4.43,0,.28c0,.36-.31.36-.94,0l-.54-.31a1.67,1.67,0,0,1-.92-1.08l-.81-4.34a2.92,2.92,0,0,0-.31-.81,1.56,1.56,0,0,0-.56-.51l-.36-.21V130c0,.43-.31.47-.92.12l-.52-.3C360.39,129.51,360.08,129.11,360.08,128.68Zm3.21-5.73a.4.4,0,0,0,.58-.12,2.14,2.14,0,0,0,.23-1.17,3.63,3.63,0,0,0-.23-1.39,1.63,1.63,0,0,0-.62-.75l-.81-.47v3.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.63,132.63a16.34,16.34,0,0,1-1-6.14c0-2.44.34-4.07,1-4.87s1.72-.8,3.14,0a6.66,6.66,0,0,1,1.33,1,1.51,1.51,0,0,1,.47,1.15,3.48,3.48,0,0,1-.2,1.27c-.14.32-.31.38-.51.17a5,5,0,0,0-1-.77c-.61-.35-1.07-.24-1.37.33a7.54,7.54,0,0,0-.45,3.14,12.28,12.28,0,0,0,.45,3.68,3.33,3.33,0,0,0,1.44,2,2.86,2.86,0,0,0,.49.23,3.56,3.56,0,0,0,.52.13.48.48,0,0,1,.14.06,1.21,1.21,0,0,1,.46.77,6,6,0,0,1,.15,1.44.94.94,0,0,1-.09.46.32.32,0,0,1-.35.14,2.92,2.92,0,0,1-.69-.19,5.06,5.06,0,0,1-.89-.42A7.24,7.24,0,0,1,368.63,132.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.12,137.78a1.58,1.58,0,0,1-.14-.7V124.44a.74.74,0,0,1,.14-.54c.09-.08.24-.06.43,0l4.51,2.61a.76.76,0,0,1,.33.44,2.34,2.34,0,0,1,.11.83v.63a1.5,1.5,0,0,1-.11.72c-.07.12-.18.13-.33,0l-2.69-1.56v3l2.38,1.37a.77.77,0,0,1,.34.44,2.71,2.71,0,0,1,.11.84v.63a1.59,1.59,0,0,1-.11.71c-.07.13-.18.14-.34,0l-2.38-1.37v3.3l2.7,1.56a.7.7,0,0,1,.33.43,2.71,2.71,0,0,1,.1.84v.63a1.71,1.71,0,0,1-.1.72c-.06.12-.17.14-.33.05l-4.52-2.61A1.07,1.07,0,0,1,375.12,137.78Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcommercecampaignAmico);
export default __webpack_public_path__ + "static/media/Ecommerce campaign-amico.bf373140a72095cd91b5b76cd702194b.svg";
export { ForwardRef as ReactComponent };